/*
Author: LiuBo
Date: 2018-11-27
Desc: JFIT 网上交易公共方法
*/
import conf from "@/config/index";
import req from "@/assets/js/req";
import { httpClient } from "../assets/js/http";
import urls from "@/api/urls";
import cache from "@/assets/js/cache";
import store from "@/store";
import Vue from "vue";
import fundApi from "@/api/fund";
import userApi from "@/api/user";
import format from "date-fns/format";
import buyverificationhtml from "@/constant/buyverification_html.js";
import commonApi from "@/api/common";

function hasParamValue(value) {
    return value !== "" && value !== undefined && value !== null;
}

// util_jfit 会和 util.js 在 src/util/index.js 中合并导出，这里避免反向 import 造成循环依赖。
// 网查模式判断保持和 util.isWebQueryMode 一致：优先读 CMS 参数 10105016，未配置时兼容老配置 hideFunc=false。
function isWebQueryModeForCheck() {
    const userInfo = cache.getUser() || {};
    const userOtherInfo = cache.getUserOtherInfo() || {};
    const queryLoginFlag =
        userInfo.orgProductQueryLoginFlag || userOtherInfo.orgProductQueryLoginFlag;
    const invtp = String(userInfo.invtp || userOtherInfo.invtp || "");
    if (queryLoginFlag === "1" || ["0", "2"].includes(invtp)) {
        return true;
    }

    const params = cache.getParams();
    const companyParamValue = cache.getCompanyInfoParam("10105016");
    const paramValue = hasParamValue(companyParamValue)
        ? companyParamValue
        : params["10105016"] && params["10105016"].paramvalue
        ? params["10105016"].paramvalue
        : "";
    if (paramValue !== "") {
        return String(paramValue) === "1";
    }
    return conf.hideFunc === false;
}

function shouldCheckMobileBindFlag() {
    const params = cache.getParams();
    const companyParamValue = cache.getCompanyInfoParam("10114004");
    const paramValue = hasParamValue(companyParamValue)
        ? companyParamValue
        : params["10114004"] && params["10114004"].paramvalue
        ? params["10114004"].paramvalue
        : "";
    // 参数 10114004 控制登录后是否校验手机号绑定标识；未下发时保持历史弹窗逻辑。
    return paramValue === "" ? true : String(paramValue).trim() === "1";
}

function isPersonalBuyBusinessDisabledForCheck() {
    return cache.getCompanyInfoParam("10102048") === "1";
}

/* 系统常量
 */
let queryRate = null; // 费率查询定时器
let CommonConst = {
    // 基金状态
    FS_OnTrade: "0", // 交易
    FS_OnIssue: "1", // 发行
    FS_IssueSucc: "2", // 发行成功
    FS_IssueFail: "3", // 发行失败
    FS_OffTrade: "4", // 基金停止交易
    FS_OffBid: "5", // 停止申购
    FS_OffRedeem: "6", // 停止赎回
    FS_OnSetBal: "7", // 权益登记
    FS_OnDivdent: "8", // 产品终止
    FS_CloseFund: "9", // 基金封闭
    FS_EndFund: "a", // 基金终止

    // 收费类型
    ST_Before: "0", // 前收费
    ST_After: "1", // 后收费
    RISK_INFO: [
        {
            risk: "01",
            affordability: "低级",
            describe:
                "在基金投资过程中，保护本金不受损失和保持资产的流动性是您的首要目标。您对投资的态度是希望投资收益稳定，" +
                "不愿或不能承担高风险以换取高收益，通常不太在意资金是否有较大增值，追求稳定。"
        },
        {
            risk: "02",
            affordability: "中低级",
            describe:
                "稳定是您首要考虑的因素之一。在基金投资中，您希望在保证本金安全的基础上能有一些增值收入。追求较低的风险，" +
                "对投资回报的要求不是太高。"
        },
        {
            risk: "03",
            affordability: "中级",
            describe:
                "在基金投资的过程中，风险较小的情况下获得一定的收益是您主要的投资目的。您通常愿意使本金面临一定的风险，但在做投资" +
                "决定时，会仔细地对将要面临的风险进行认真的分析。总体来看，您愿意承受市场的平均风险。"
        },
        {
            risk: "04",
            affordability: "中高级",
            describe:
                "在基金投资中，您渴望有较高的投资收益，但又不愿承受较大的风险；可以承受一定的投资波动，但是希望自己的投资" +
                "风险小于市场的整体风险。您有较高的收益目标，且对风险有清醒的认识。"
        },
        {
            risk: "05",
            affordability: "高级",
            describe:
                "在基金投资中，您通常专注于投资的长期增值，并愿意为此承受较大的风险。短期的投资波动并不会对您造成大的影响，" +
                "追求超高的回报才是您关注的目标。"
        }
    ],
    FUND_HIGHRISK_INFO:
        "产品列表已根据您的风险等级做筛选调整。您已主动要求查看高于您风险等级的产品。",
    FUND_RISK_INFO:
        "产品列表已根据您的风险等级进行匹配，目前展示的是符合您风险等级的产品。如您需要查看高于您风险承受能力的产品，",
    policyTypes: {
        addBankCard: "b", // 增卡
        buy: "f", // 认申购
        plan: "k", // 定投
        change: "h", // 转换
        sell: "o", // 赎回
        login: "l", // 登录
        xjbBuy: "i", // 现金宝充值"
        sellToBuy: "r", // 赎回转申购
        sign: "p", // 签约
        unsign: "q" // 解约
    }
};
let setTime = null;
// 交易页适当性一次性放行标志，按路由和基金隔离，消费后即失效。
const TRADE_SDX_ACCESS_PREFIX = "_tradeSdxAccess_";

export const policyTypesEnum = {
    addBankCard: "b", // 增卡
    buy: "f", // 认申购
    plan: "k", // 定投
    change: "h", // 转换
    sell: "o", // 赎回
    login: "l", // 登录
    xjbBuy: "i", // 现金宝充值"
    sellToBuy: "r", // 赎回转申购
    sign: "p", // 签约
    unsign: "q", // 解约
    transfer: "M" // 转账
};

export const sceneEnum = {
    login: "1", // 登录
    activeCard: "2", // 激活银行卡
    addBankCard: "3", // 增卡
    bookBuy: "4", // 预约申购
    bookRedeem: "5", // 预约赎回
    buy: "6", // 认申购
    change: "8", // 转换,
    open: "9", // 开户
    plan: "10", // 定投
    register: "11", // 注册,
    resetPwd: "12", // 重置密码
    sell: "13", // 赎回
    sign: "14", // 签约
    unsign: "15", // 解约，
    sellToBuy: "16", // 赎回转购,
    budgetBuy: "17", // 省钱购,
    batchTrade: "18", // 批量交易
    quickSell: "19", // 快速赎回
    xjbBuy: "20", // 现金宝充值
    riskConfirm: "21" // 风险结果确认
};

/* 校验用户信息完善程度
 @return [Boolean] 返回需要进行的操作校验结果，true or false
 */
const userCheck = (info, cate, path) => {
    // if (info.usertype !== "3" && info.usertype !== "4") return [];
    if (!cache.getBinded()) return [];
    if (isWebQueryModeForCheck()) return [];
    let infoCheckResult = [];
    // 检查结果四位数字
    // 交易密码
    let _obj = {};
    /* if (info.tradepwdexpired === "1" || info.tradepwdreset === "1") {
        _obj = {
            id: "0101",
            text: "您的交易密码已重置或过期，为了你的交易安全请修改交易密码",
            tit: "交易密码修改",
            name: ""
        };
        infoCheckResult.push(_obj);
    } */
    // info.certexpired = "1"; // 临时代码
    // info.daystoexpired = "1"; // 临时代码
    // 纯代销不校验用户信息
    if (
        info.custbelongto != "2" &&
        (Vue.prototype.$util.isEmpty(info.nationality) ||
            Vue.prototype.$util.isEmpty(info.birthday) ||
            Vue.prototype.$util.isEmpty(info.delivertype) ||
            Vue.prototype.$util.isEmpty(info.benefisself) ||
            Vue.prototype.$util.isEmpty(info.actualisself) ||
            Vue.prototype.$util.isEmpty(info.vocationcode) ||
            // ((info.vocationcode == "14" || info.vocationcode == "29") &&
            //     Vue.prototype.$util.isEmpty(info.vocationsupple)) ||
            Vue.prototype.$util.isEmpty(info.annualincome) ||
            Vue.prototype.$util.isEmpty(info.livingcountry) ||
            Vue.prototype.$util.isEmpty(info.livingaddress) ||
            (info.livingcountry == "CN" &&
                Vue.prototype.$util.isEmpty(info.livingaddressprovince)) ||
            (info.certexpired === "1" &&
                path !== "/fund/sellfund" &&
                path !== "/fund/ordersell" &&
                path !== "/currencyfund/currencyredemption") ||
            (!Vue.prototype.$util.isEmpty(info.daystoexpired) &&
                !sessionStorage.getItem("daystoexpiredFlag")) ||
            (info.certificatetype === "0B" && info.certificateno.length === 15))
    ) {
        if (info.certexpired === "1") {
            if (path !== "/fund/sellfund") {
                _obj = {
                    id: "0102",
                    text:
                        "您的" +
                        Vue.prototype.$cache.getDict("130007", info.certificatetype) +
                        "有效期已过期，请先修改证件有效期",
                    tit: "证件过期",
                    name: ""
                };
                infoCheckResult.push(_obj);
            }
        } else if (
            !Vue.prototype.$util.isEmpty(info.daystoexpired) &&
            !sessionStorage.getItem("daystoexpiredFlag")
        ) {
            _obj = {
                id: "0102",
                text:
                    "您的" +
                    Vue.prototype.$cache.getDict("130007", info.certificatetype) +
                    Vue.prototype.$util.fmtDate(info.validdate, "CN") +
                    "到期，请及时更新",
                tit: "证件更新",
                name: ""
            };
            infoCheckResult.push(_obj);
        } else {
            _obj = {
                id: "0102",
                text: "您的用户信息未完善，请先完善",
                tit: "用户信息",
                name: ""
            };
            infoCheckResult.push(_obj);
        }
    }
    // 风险评测
    let assettype = cache.getCompanyInfoParam("1000056");
    if (assettype) {
        // 取专户风测数据
        let acctRiskInfo =
            info.acctRiskInfoDtoList &&
            info.acctRiskInfoDtoList.find((item) => item.assettype == "3");
        // 独立风评
        if (info.riskexpired === "1") {
            _obj = {
                id: "0201",
                text: "您还未做风险评测或评测已过期，请先完善",
                tit: "风险评测",
                name: "",
                assettype: ""
            };
            infoCheckResult.push(_obj);
        } else if (
            acctRiskInfo &&
            acctRiskInfo.custrisk &&
            info.phydate > acctRiskInfo.riskenddate
        ) {
            _obj = {
                id: "0201",
                text: "您的专户风测已过期，请先完善",
                tit: "风险评测",
                name: "",
                assettype: "3"
            };
            infoCheckResult.push(_obj);
        }
    } else {
        if (info.riskexpired === "1") {
            _obj = {
                id: "0201",
                text: "您还未做风险评测或评测已过期，请先完善",
                tit: "风险评测",
                name: "",
                assettype: ""
            };
            infoCheckResult.push(_obj);
        }
    }
    /* //ocr证件是否上传
    if (info.needOcrUpload === "1") {
        _obj = {
            id: "0108",
            text: "您的证件资料还未上传，请先上传有效证件",
            tit: "证件未上传",
            name: ""
        };
        infoCheckResult.push(_obj);
    } */
    // CRS
    if (info.needfillcrs === "1") {
        _obj = {
            id: "0104",
            text: "您还未完善CRS信息，请先完善",
            tit: "CRS信息",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    // 准入
    // if (info.isneedidentify === "1") {
    //     _obj = {
    //         id: "0105",
    //         text: "您还未做投资者准入，请先完善",
    //         tit: "投资者准入",
    //         name: ""
    //     };
    //     infoCheckResult.push(_obj);
    // }
    // 适当性补录
    // if (
    //     (!info.debt ||
    //         !info.investmentedu ||
    //         !info.investmentwork ||
    //         !info.investmentexp ||
    //         !info.investmentterm ||
    //         !info.execeptedearning ||
    //         !info.affordableloss ||
    //         !info.investfundtype) &&
    //     info.riskexpired !== "1"
    // ) {
    //     _obj = {
    //         id: "0103",
    //         text: "您还未完善适当性信息，请先完善",
    //         tit: "适当性信息",
    //         name: ""
    //     };
    //     infoCheckResult.push(_obj);
    // }
    // 只检查一级菜单
    if (cate) {
        return infoCheckResult;
    }
    // 持有银行卡
    if (info.totalcardnum === "0") {
        _obj = {
            id: "0202",
            text: "您还未持有可用银行卡，请先完善",
            tit: "银行卡",
            name: ""
        };
        infoCheckResult.push(_obj);
    }
    return infoCheckResult;
};

/* 判断用户需完善信息
 @param [Array] check 需要完善的用户信息列表
 @param [Function] next 路由 next
 @param {Boolean} cate 即 checkAcct 内 _f：true 表示路由不含交易强校验「3」，取消可 next() 放行；false 含「3」取消须 next(false) 禁止绕过交易前完善
 */
const initCheck = (check, next, cate, navigateOpt) => {
    const nav = navigateOpt || next;
    let _html = "";
    let assettype = "";
    let custrisk = "";
    let path = cache.getUser().certexpired === "1" ? "modifyinfo" : "checkacct";
    check.forEach((item) => {
        assettype = item.assettype || "*";
        custrisk = item.custrisk || "";
        _html +=
            '<div class="user-info-check"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>' +
            item.text +
            "</div>";
    });
    Vue.prototype
        .$alert(_html, "信息完善", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即前往处理",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    nav({
                        name: path,
                        query: {
                            cate: cate,
                            assettype: assettype,
                            custrisk: custrisk
                        }
                    });
                    done();
                } else {
                    sessionStorage.setItem("daystoexpiredFlag", "1");
                    Vue.prototype.$message({
                        type: "info",
                        message: "放弃完善用户信息"
                    });
                    done();
                    // 仅 check「2」：放行原目标（如登录后进首页）；含 check「3」：须阻断交易路由，不可 next() 绕过
                    if (cate) {
                        nav();
                    } else {
                        nav(false);
                    }
                }
            }
        })
        .then(() => {
            return false;
        })
        .catch(() => {
            return false;
        });
};

const initCheck2 = (check, next, cate) => {
    let dialogInfo = "您的证件资料还未上传，请先上传有效证件";
    if (cache.getUser().certexpired === "1") {
        if (cache.getUser().certificatetype !== "0") {
            dialogInfo = "您的证件有效期已经过期，请重新上传证件照并修改证件有效期";
        } else {
            dialogInfo = "您的证件有效期已经过期，请重新上传有效证件以更新证件有效期";
        }
    }
    let _html =
        '<div class="user-info-check"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>' +
        dialogInfo +
        "</div>";
    Vue.prototype
        .$alert(_html, "信息完善", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即前往处理",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    next({
                        name: "ocrinfoupd",
                        query: {
                            certificatetype: cache.getUser().certificatetype
                        }
                    });
                    done();
                } else {
                    Vue.prototype.$message({
                        type: "info",
                        message: "放弃完善用户信息"
                    });
                    done();
                    if (cate) {
                        next();
                    } else {
                        next(false);
                    }
                }
            }
        })
        .then(() => {
            return false;
        })
        .catch(() => {
            return false;
        });
};
// 转换身份证位数提示及操作。
const initCheck3 = (next, navigateOpt) => {
    const nav = navigateOpt || next;
    let pwdHtml = cache.getPwdCheck("B1")
        ? "<input id='dialog-pwd' style='display: block;width:200px;height:22px;line-height:22px;' type='password' placeholder='请输入交易密码' maxlength='16'/>"
        : "";
    let _html =
        '<div class="user-info-check"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>查询到您的身份证号码为15位，业务操作需要进行身份证升位，否则将无法登陆首页。<br />需要将身份证升位到' +
        cache.getUser().newcertno +
        "吗？<br />" +
        pwdHtml +
        "</div>";
    Vue.prototype
        .$alert(_html, "身份证升位", {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即升位",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    let datas = cache.getPwdCheck("B1")
                        ? {
                              tradepwd: Vue.prototype.$util.enc(
                                  document.getElementById("dialog-pwd").value
                              )
                          }
                        : {};
                    req({
                        method: "PUT",
                        url: "acct/modify/certno",
                        timeout: 20000,
                        data: datas
                    })
                        .then((res) => {
                            if (res.code === "0000000") {
                                const info = cache.getUser();
                                info.modifycertno = "0";
                                info.certificateno = cache.getUser().newcertno;
                                store
                                    .dispatch("setInfo", info)
                                    .then(() => {
                                        Vue.prototype.$message({
                                            type: "success",
                                            message: "身份证升位成功！"
                                        });
                                    })
                                    .catch(() => {})
                                    .then(() => {
                                        // 守卫侧已拦截本次跳转，升位结束后须调用 next 结束守卫
                                        nav();
                                    });
                            } else {
                                this.$message.error(res.msg);
                                Vue.prototype.$util
                                    .request("common/logout", {}, false, false)
                                    .then((res) => {
                                        if (res.data) {
                                            store.dispatch("logout", res.data[0]).then(() => {
                                                nav({
                                                    name: "login"
                                                });
                                            });
                                        }
                                    });
                            }
                        })
                        .catch(() => {
                            Vue.prototype.$util
                                .request("common/logout", {}, false, false)
                                .then((res) => {
                                    if (res.data) {
                                        store.dispatch("logout", res.data[0]).then(() => {
                                            nav({
                                                name: "login"
                                            });
                                        });
                                    }
                                });
                        });
                    done();
                } else {
                    Vue.prototype.$message({
                        type: "info",
                        message: "已放弃升位身份证号码，退回登录页"
                    });
                    Vue.prototype.$util.request("common/logout", {}, false, false).then((res) => {
                        if (res.data) {
                            store.dispatch("logout", res.data[0]).then(() => {
                                nav({
                                    name: "login"
                                });
                            });
                        }
                    });
                    done();
                }
            }
        })
        .then(() => {
            return false;
        })
        .catch(() => {
            return false;
        });
};
/* 判断是否含有三个或三个以上的连续字符
    @param {String} inputpass 判读连续字符值
    @param {String} n 连续字符个数,默认2,必须大于1
    @return [Boolean] 校验结果，true or false
    */
const checkSeries = (inputpass, n) => {
    n = Number(n) || 2;
    if (inputpass.length < n + 1) return true;
    for (let i = 0; i < inputpass.length - n; i++) {
        let _charPwd = inputpass.charCodeAt(i);
        let _index = 0;
        let _indexCom = 0;
        for (let j = 1; j < n + 1; j++) {
            const _x = inputpass.charCodeAt(i + j);
            if (isNaN(_x)) {
                return true;
            }
            if (_x - j === _charPwd || _x === _charPwd) {
                if (_x - j === _charPwd) {
                    _index++;
                } else {
                    _index = 0;
                }
                if (_x === _charPwd) {
                    _indexCom++;
                } else {
                    _indexCom = 0;
                }
            } else {
                break;
            }
        }
        if (_index >= n || _indexCom >= n) {
            return true;
        }
    }
    return false;
};

// 是否包含指定长度的连续数字（正序或倒序），如 123 / 321
const hasSequentialDigits = (str, n = 3) => {
    if (typeof str !== "string" || str.length < n) {
        return false;
    }
    for (let i = 0; i <= str.length - n; i++) {
        const slice = str.slice(i, i + n);
        if (!/^\d+$/.test(slice)) continue;
        let inc = true;
        let dec = true;
        for (let j = 1; j < n; j++) {
            const prev = Number(slice[j - 1]);
            const curr = Number(slice[j]);
            if (curr !== prev + 1) inc = false;
            if (curr !== prev - 1) dec = false;
            if (!inc && !dec) break;
        }
        if (inc || dec) return true;
    }
    return false;
};

// 字符串是否全部为相同数字
const isAllDigitsSame = (str) => {
    if (typeof str !== "string" || str.length === 0) {
        return false;
    }
    const regex = new RegExp("^" + str[0] + "+$");
    return regex.test(str);
};

// 基于公司参数的通用密码校验（对标 kdtup-web/src/utils/validate.ts 中 validPwd）
const validPwdByRules = (value, rules) => {
    if (/\s/.test(value)) {
        return false;
    }
    const _p = rules || {};
    const min = Number(_p.pwdminlength || 6);
    const max = Number(_p.pwdmaxlength || 16);
    if (value.length < min || value.length > max) {
        return false;
    }
    // 密码必须包含数字
    if (_p.pwdneednumber === "1" && !/[0-9]/.test(value)) {
        return false;
    }
    // 密码必须包含小写字母
    if (_p.pwdneedlowerletter === "1" && !/[a-z]/.test(value)) {
        return false;
    }
    // 密码必须包含大写字母
    if (_p.pwdneedupperletter === "1" && !/[A-Z]/.test(value)) {
        return false;
    }
    // 密码必须包含特殊字符
    if (_p.pwdspecial === "1" && !/[~!@#$%^&*()_+<>,.?/:;\\[\]{}]/.test(value)) {
        return false;
    }
    // 密码只能输入启用的字符
    if (_p.pwdlimitused === "1") {
        // 直接在字符类中硬编码允许的字符集合，避免动态转义带来的正则错误
        let characterClass = "";
        if (_p.pwdneednumber === "1") {
            characterClass += "0-9";
        }
        if (_p.pwdneedlowerletter === "1") {
            characterClass += "a-z";
        }
        if (_p.pwdneedupperletter === "1") {
            characterClass += "A-Z";
        }
        if (_p.pwdspecial === "1") {
            // 注意这里的 [] 需要在字符串中写成 \\[ 和 \\]，以便在正则字符类中被正确识别
            characterClass += "~!@#$%^&*()_+<>,.?/:;\\[\\]{}";
        }
        if (characterClass) {
            const reg = new RegExp("^[" + characterClass + "]*$");
            if (!reg.test(value)) {
                return false;
            }
        }
    }
    // 不能包含连续或重复字符
    if (_p.pwdnotcontinu === "1" && checkSeries(value, 2)) {
        return false;
    }
    // 交易密码不能包含连续数字
    if (_p.pwdDiscontinuousNmber === "1" && hasSequentialDigits(value, 3)) {
        return false;
    }
    // 交易密码全部数字不能相同
    if (_p.pwdCannotBeTheSame === "1" && isAllDigitsSame(value)) {
        return false;
    }
    // 交易密码黑名单
    if (_p.pwdblacklist && _p.pwdblacklist.length > 0) {
        const list = _p.pwdblacklist.split("、");
        if (list.includes(value)) {
            return false;
        }
    }
    return true;
};

// 获取登录密码规则（对标 kdtup-web 中 usePwdRules）
const getLoginPwdRules = () => {
    return {
        pwdneednumber: cache.getCompanyInfoParam("10104001") || "0",
        pwdneedlowerletter: cache.getCompanyInfoParam("10104002") || "0",
        pwdneedupperletter: cache.getCompanyInfoParam("10104003") || "0",
        pwdspecial: cache.getCompanyInfoParam("10104004") || "0",
        pwdlimitused: cache.getCompanyInfoParam("10104005") || "0",
        pwdminlength: Number(cache.getCompanyInfoParam("10104006") || "6"),
        pwdmaxlength: Number(cache.getCompanyInfoParam("10104007") || "16"),
        pwdDiscontinuousNmber: "0",
        pwdCannotBeTheSame: "0",
        pwdblacklist: ""
    };
};

// 获取交易密码规则（对标 kdtup-web 中 usePwdRules）
const getTradePwdRules = () => {
    return {
        pwdneednumber: cache.getCompanyInfoParam("10104008") || "0",
        pwdneedlowerletter: cache.getCompanyInfoParam("10104009") || "0",
        pwdneedupperletter: cache.getCompanyInfoParam("10104010") || "0",
        pwdspecial: cache.getCompanyInfoParam("10104011") || "0",
        pwdlimitused: cache.getCompanyInfoParam("10104012") || "0",
        pwdminlength: Number(cache.getCompanyInfoParam("10104013") || "6"),
        pwdmaxlength: Number(cache.getCompanyInfoParam("10104014") || "16"),
        pwdDiscontinuousNmber: cache.getCompanyInfoParam("10104017") || "0",
        pwdCannotBeTheSame: cache.getCompanyInfoParam("10104018") || "0",
        pwdblacklist: cache.getCompanyInfoParam("10104019") || ""
    };
};

// 通用密码规则文案生成（对标 kdtup-web/src/utils/validate.ts 中 pwdCheckText）
const getPwdCheckText = (_p) => {
    const min = Number((_p && _p.pwdminlength) || 6) || 6;
    const max = Number((_p && _p.pwdmaxlength) || 16) || 16;

    if (_p && _p.pwdneedpurenumber === "1") {
        const extra = [];
        if (_p.pwdnotcontinu === "1") extra.push("不能包含连续或重复数字");
        if (_p.pwdDiscontinuousNmber === "1") extra.push("不能包含连续数字");
        if (_p.pwdCannotBeTheSame === "1") extra.push("不能全部相同");
        if (_p.pwdblacklist && _p.pwdblacklist.length > 0) extra.push("不能为弱密码");
        extra.push("不能包含空格");
        return "请输入" + min + "～" + max + "位纯数字，" + extra.join("，");
    }

    const required = [];
    if (_p && _p.pwdneednumber === "1") required.push("数字");
    const needLower = _p && _p.pwdneedlowerletter === "1";
    const needUpper = _p && _p.pwdneedupperletter === "1";
    if (needLower && needUpper) required.push("大小写字母");
    else if (needLower) required.push("小写字母");
    else if (needUpper) required.push("大写字母");
    if (_p && _p.pwdspecial === "1") required.push("特殊字符");

    let text = "请输入" + min + "～" + max + "位字符";
    if (required.length > 0) {
        text += "，需包含" + required.join("+");
    }

    const extra = [];
    if (_p && _p.pwdlimitused === "1") extra.push("仅可输入启用的字符");
    if (_p && _p.pwdnotcontinu === "1") extra.push("不能包含连续或重复字符");
    if (_p && _p.pwdDiscontinuousNmber === "1") extra.push("不能包含连续数字");
    if (_p && _p.pwdCannotBeTheSame === "1") extra.push("全部为数字时不能相同");
    if (_p && _p.pwdblacklist && _p.pwdblacklist.length > 0) extra.push("不能为弱密码");
    extra.push("不能包含空格");

    return text + "，" + extra.join("，");
};

/* 判断密码是否符合规范（统一走新规则）
 @param [String] value 需要校验密码
 @param [Boolean|String] flag 是否校验交易/查询密码，flag === "1" 表示查询密码
 @return [String/Boolean] 校验结果信息，false 符合密码规范，String 为错误提示
 */
const checkSameChar = (value, flag) => {
    if (value === "") {
        return "请输入密码";
    }
    if (/\s/.test(value)) {
        return "密码不能含有空格";
    }
    // 登录密码 / 交易密码走统一规则
    const rules = flag ? getTradePwdRules() : getLoginPwdRules();
    const passed = validPwdByRules(value, rules);
    if (!passed) {
        return "密码格式不正确";
    }
    return false;
};
/* 判断字符串字节长度
 @param [String] value 字符串
 @return [String/Boolean] 字符串字节长度
 */
const getBLen = (str) => {
    if (str == null) return 0;
    if (typeof str !== "string") {
        str += "";
    }
    return str.replace(/[^\u4E00-\u9FA5\uf900-\ufa2d]/g, "ab").length;
};
/* 判断验证码是否符合规范
 @param [String] value 需要校验验证码
 @return [String/Boolean] 校验结果信息，false符合验证码规范，String验证码校验不通过信息
 */
const checkVerifyCode = (value) => {
    if (value === "") {
        return "请输入验证码";
    }
    const b = "4";
    const c = "4";
    let a = b !== c ? b + "-" + c : b;
    let e = "数字或字母";
    if (value.length < b || value.length > c) {
        return "验证码应为" + a + "位" + e;
    }
    const pattern = /^[0-9a-zA-Z]*$/g;
    if (!pattern.test(value)) {
        return "验证码应为" + a + "位" + e;
    }
};
/* 校验身份证号码
 @inParam [String] value 获取到的校验项值
 @return [Boolean] 校验结果 true为身份证号码
 */
const checkIdCard = (value) => {
    value = value.trim();
    if (value && value.length === 18) {
        let sum = 0;
        // 系数
        const weight = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        // 参照余数
        const reference = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2];
        const lastNumber = value[17] === "X" || value[17] === "x" ? 10 : Number(value[17]);
        for (let i = 0; i < 17; i++) {
            sum = sum + Number(value[i]) * weight[i];
        }
        if (reference[sum % 11] !== lastNumber) {
            return false;
        } else {
            return true;
        }
    } else if (value && value.length === 15) {
        const reg =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
        return reg.test(value);
    }
    // const reg =
    //     /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    // if (reg.test(code)) {
    //     return true;
    // }
    // return false;
};
const toThousands = (num, precision) => {
    if (/^.*\..*$/.test(num)) {
        const pointIndex = num.lastIndexOf(".");
        let intPart = num.substring(0, pointIndex);
        let pointPart = num.substring(pointIndex + 1, num.length);
        intPart = intPart + "";
        const re = /(-?\d+)(\d{3})/;
        while (re.test(intPart)) {
            intPart = intPart.replace(re, "$1,$2");
        }
        num = intPart + "." + pointPart;
    } else {
        num = num + "";
        const re = /(-?\d+)(\d{3})/;
        while (re.test(num)) {
            num = num.replace(re, "$1,$2");
        }
        const pointPart = "".padEnd(precision, "0");
        num = pointPart ? num + "." + pointPart : num;
    }
    return num;
};
const fmtNum = (num, precision = 2, rounding = true) => {
    if ((num !== 0 && !num) || (num + "").trim() === "" || isNaN(Number(num))) {
        return "--";
    }

    num = Number(num) + ""; // 处理后台传的小于0的值，比如'.9984'
    if (/^.*\..*$/.test(num)) {
        // num有小数位
        const pointIndex = num.lastIndexOf(".");
        let intPart = num.substring(0, pointIndex);
        let pointPart = num.substring(pointIndex + 1, num.length);
        intPart = intPart + "";
        const re = /(-?\d+)(\d{3})/;
        while (re.test(intPart)) {
            intPart = intPart.replace(re, "$1,$2");
        }
        if (pointPart.length > precision) {
            if (rounding === true) {
                num = parseFloat(num).toFixed(precision); // 四舍五入会影响千分位格式
                num = toThousands(num, precision); // num转为千分位
            } else {
                pointPart = pointPart.substring(0, precision);
                num = pointPart ? intPart + "." + pointPart : intPart;
            }
        } else {
            pointPart = pointPart.padEnd(precision, "0");
            num = intPart + "." + pointPart;
        }
    } else {
        // num为整数
        num = num + "";
        const re = /(-?\d+)(\d{3})/;
        while (re.test(num)) {
            num = num.replace(re, "$1,$2");
        }
        const pointPart = "".padEnd(precision, "0");
        num = pointPart ? num + "." + pointPart : num;
    }
    return num;
};

const fmtToPercent = (num, maxDigits = 2) => {
    if ((num !== 0 && !num) || (num + "").trim() === "" || isNaN(Number(num))) {
        return "--";
    }

    return num.toLocaleString("en-US", {
        style: "percent",
        minimumFractionDigits: maxDigits,
        maximumFractionDigits: maxDigits
    });
};

const getBankInfoFunc = (_arr, params) => {
    _arr.forEach((item) => {
        if (item.identifytype.indexOf("s") > -1) {
            item.bankauthtype = "1";
        } else if (item.identifytype.indexOf("r") > -1) {
            item.bankauthtype = "2";
        } else {
            item.bankauthtype = "0";
        }

        if (item.identifytype.indexOf("t") > -1) {
            item.identifytype = "1";
        } else if (item.identifytype.indexOf("u") > -1) {
            item.identifytype = "2";
        } else {
            item.identifytype = "0";
        }
    });
    let bank = [];
    const x = {};
    // 合并银行卡
    for (let i of _arr) {
        if (
            (params.biztype2 == "exists" || params.biztype2 == "open") &&
            (i.identifytype == 0 || i.paycenterid == "0001" || i.paycenterid == "1000")
        ) {
            continue;
        }
        if (
            (params.biztype2 != "exists" || params.biztype2 != "open") &&
            i.identifytype == 0 &&
            i.paycenterid != "0001" &&
            i.paycenterid != "1000"
        ) {
            continue;
        }
        if (i.channelid === conf.const.TTY_CHANLEID) {
            i.bankcode = "TTY";
        }
        if (!x[i.bankcode]) {
            i.child = [];
            i.child.push(i);
            bank.push(i);
            x[i.bankcode] = true;
        } else {
            for (let j of bank) {
                if (j.bankcode === i.bankcode) {
                    j.child.push(i);
                }
            }
        }
    }
    return bank;
};

/**
 * BUG-14785：登录后进首页不在路由守卫里弹「升位/绑手机号/银行卡/信息完善」（避免登录页或路由过渡态叠窗），
 * 改由首页 dynaView + homePopupQueue 串行弹出（需在首页 mounted 注册）。
 */
export function registerHomeDeferredAcctDialogs(queue) {
    if (isWebQueryModeForCheck()) return;

    const isHomeRouteVm = (vm) => vm && vm.$route && vm.$route.name === "home";

    queue.addStep({
        id: "homeDeferModifycertno",
        order: 10,
        shouldShow: async (vm) => {
            if (isWebQueryModeForCheck()) return false;
            if (!isHomeRouteVm(vm)) return false;
            const cur = cache.getUser();
            return cache.getBinded() && cur && cur.modifycertno === "1";
        },
        show: (vm) =>
            new Promise((resolve) => {
                let settled = false;
                const finish = () => {
                    if (!settled) {
                        settled = true;
                        resolve();
                    }
                };
                const nav = (loc) => {
                    if (!loc) {
                        finish();
                        return;
                    }
                    vm.$router
                        .push(loc)
                        .catch(() => {})
                        .finally(finish);
                };
                initCheck3(finish, nav);
            })
    });

    queue.addStep({
        id: "homeDeferBindMobile",
        order: 11,
        shouldShow: async (vm) => {
            if (isWebQueryModeForCheck()) return false;
            if (!isHomeRouteVm(vm)) return false;
            const cur = cache.getUser();
            const _y = sessionStorage.getItem("alreadyread") || "";
            if (
                !cache.getBinded() ||
                !cur ||
                cur.mobilebindflag === "1" ||
                !shouldCheckMobileBindFlag()
            ) {
                return false;
            }
            return _y.indexOf("bind_mobile_warn") === -1;
        },
        show: (vm) => {
            const _y = sessionStorage.getItem("alreadyread") || "";
            sessionStorage.setItem("alreadyread", _y + ",bind_mobile_warn");
            sessionStorage.setItem("_bindingMobileDialog", "1");
            return vm
                .$confirm("您尚未绑定手机号，为了账户安全，请绑定手机号", "温馨提示", {
                    confirmButtonText: "去绑定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    sessionStorage.removeItem("_bindingMobileDialog");
                    return vm.$router.push({
                        path: "/acctManager?activeIndex=2&NOCHECK=1"
                    });
                })
                .catch(() => {
                    sessionStorage.removeItem("_bindingMobileDialog");
                })
                .finally(() => {
                    sessionStorage.removeItem("_bindingMobileDialog");
                });
        }
    });

    queue.addStep({
        id: "homeDeferBankInactive",
        order: 12,
        shouldShow: async (vm) => {
            if (isWebQueryModeForCheck()) return false;
            if (isPersonalBuyBusinessDisabledForCheck()) return false;
            if (!isHomeRouteVm(vm)) return false;
            const cur = cache.getUser();
            const _y = sessionStorage.getItem("alreadyread") || "";
            if (_y.indexOf("5") !== -1) return false;
            return !!(cur && cur.unactivecardnum && Number(cur.unactivecardnum) > 0);
        },
        show: (vm) => {
            const cur = cache.getUser();
            const _y = sessionStorage.getItem("alreadyread") || "";
            sessionStorage.setItem("alreadyread", _y + ",5");
            return vm
                .$confirm(
                    "您还有" + cur.unactivecardnum + "张银行卡未激活，请前往激活。",
                    "银行卡信息提示",
                    {
                        confirmButtonText: "前往",
                        cancelButtonText: "继续访问",
                        type: "warning",
                        customClass: "info-check"
                    }
                )
                .then(() => vm.$router.push({ name: "bank" }))
                .catch(() => {});
        }
    });

    queue.addStep({
        id: "homeDeferUserInfo",
        order: 13,
        shouldShow: async (vm) => {
            if (isWebQueryModeForCheck()) return false;
            if (!isHomeRouteVm(vm)) return false;
            const cur = cache.getUser();
            if (!cur) return false;
            const _y = sessionStorage.getItem("alreadyread") || "";
            if (_y.indexOf("4") !== -1) return false;
            const _f = true;
            const _check = userCheck(cur, _f, "/home");
            if (
                _check.length > 0 &&
                vm.$route.path.indexOf("checkacct") === -1 &&
                !(
                    vm.$route.path.indexOf("/fund/sellfund") === 0 ||
                    vm.$route.path.indexOf("/currencyfund/currencyredemption") === 0
                )
            ) {
                const _riskCheck = _check.find((item) => item.id === "0201");
                const _otherCheck = _check.filter((item) => item.id !== "0201");
                const _checkTarget = _riskCheck ? _otherCheck : _check;
                return _checkTarget.length > 0;
            }
            return false;
        },
        show: (vm) => {
            const cur = cache.getUser();
            const _f = true;
            const _y = sessionStorage.getItem("alreadyread") || "";
            const _check = userCheck(cur, _f, "/home");
            const _riskCheck = _check.find((item) => item.id === "0201");
            const _otherCheck = _check.filter((item) => item.id !== "0201");
            const _checkTarget = _riskCheck ? _otherCheck : _check;
            sessionStorage.setItem("alreadyread", _y.indexOf("4") === -1 ? _y + ",4" : _y);
            return new Promise((resolve) => {
                const nav = (loc) => {
                    if (loc === false) {
                        resolve();
                        return;
                    }
                    if (!loc) {
                        resolve();
                        return;
                    }
                    vm.$router
                        .push(loc)
                        .catch(() => {})
                        .finally(() => resolve());
                };
                initCheck(_checkTarget, nav, _f);
            });
        }
    });
}

export default {
    checkIdCard,
    /* 获取用户状态
  @inParam [String] 路由path
  @return [Array] 需要校验的数据
  */
    checkAcct(to, from, next, params) {
        // 如果是网查不校验任何内容
        if (isWebQueryModeForCheck()) {
            return true;
        }
        // 如果路径参数含有NOCHECK，跳过校验
        if (to.query && to.query.NOCHECK === "1") {
            return true;
        }
        // // 如果密码过期，进来先不校验其他内容
        const userOtherInfo = cache.getUserOtherInfo();
        if (userOtherInfo.specialflag && userOtherInfo.specialflag != "0") {
            return true;
        }
        // 纯代销可以进去交易査询
        if (to.path === "/traderecord" && cache.getCustnoCrm()) {
            return true;
        }
        const info = cache.getUser();
        const _cate = params.checkCate ? params.checkCate.toString() : "";
        if (
            !cache.getBinded()
            // 检查用户是否开通网上交易-5.0 默认开通所有 暂不校验 只校验是否开户
            // || !info.tradingmethod ||
            // info.tradingmethod.indexOf("2") === -1
        ) {
            if (_cate.indexOf("1") > -1) {
                // 代销用户能直接查看用户信息 -5.0   只有注册用户 与已开户用户 弃用< !(to.path === "/info/modifyinfo" && info.usertype === "2")>
                // 未绑定交易账户增卡直接跳转到绑定账户
                if (to.path === "/bank/addbank") {
                    next({
                        name: "bindnewacct"
                    });
                } else {
                    let _x = "此类操作";
                    if (_cate.indexOf("3") > -1) {
                        _x = "购买/定投基金等交易功能";
                    }
                    Vue.prototype.$belongToDialog();
                }
                return false;
            }
        }
        const _y = sessionStorage.getItem("alreadyread") || "";
        cache.initCityCountyList();
        // 检查用户信息是否完善
        if (_cate.indexOf("2") > -1 || _cate.indexOf("3") > -1) {
            // 进入首页（仅含 profile 校验「2」）：守卫侧不再弹窗，避免登录页/跳转过程中的叠窗；改由首页 registerHomeDeferredAcctDialogs 队列串行处理（BUG-14785）
            const deferAcctDialogsToHome =
                (to.name === "home" || to.path === "/home") && _cate.indexOf("3") === -1;
            if (deferAcctDialogsToHome) {
                return true;
            }
            const _f = !(_cate.indexOf("3") > -1);
            const _check = userCheck(info, _f, to.path);
            // 判断客户是否为15位身份证号码，提示并转换身份证位数，否则退出。
            if (cache.getBinded() && info.modifycertno === "1") {
                if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                    setTimeout(function () {
                        initCheck3(next);
                    }, 1500);
                } else {
                    initCheck3(next);
                }
                // 已弹出升位引导时须拦截本次导航，否则目标页（如首页）会先挂载并触发其它引导弹窗，与升位提示重叠
                return false;
            } else if (
                cache.getBinded() &&
                shouldCheckMobileBindFlag() &&
                info.mobilebindflag !== "1" &&
                (_y.indexOf("bind_mobile_warn") === -1 || !_f)
            ) {
                sessionStorage.setItem("alreadyread", _y + ",bind_mobile_warn");
                // 用于首页引导弹窗队列串行化：绑定手机号弹窗期间，暂停其他自动弹窗
                sessionStorage.setItem("_bindingMobileDialog", "1");
                Vue.prototype
                    .$confirm("您尚未绑定手机号，为了账户安全，请绑定手机号", "温馨提示", {
                        confirmButtonText: "去绑定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then(() => {
                        // 立即清理标记，回首页后其它弹窗可继续串行弹出
                        sessionStorage.removeItem("_bindingMobileDialog");
                        next({
                            path: "/acctManager?activeIndex=2&NOCHECK=1"
                        });
                    })
                    .catch(() => {
                        sessionStorage.removeItem("_bindingMobileDialog");
                        if (_f) {
                            next();
                        } else {
                            next(false);
                        }
                    })
                    .finally(() => {
                        sessionStorage.removeItem("_bindingMobileDialog");
                    });
                // 与仅 check「2」时仍 return true 会先进入首页、与引导队列叠窗的问题一致：先拦导航，再由 then/catch 里 next 继续或取消
                return false;
            } else if (
                (_y.indexOf("5") === -1 || !_f) &&
                !isPersonalBuyBusinessDisabledForCheck() &&
                info.unactivecardnum &&
                Number(info.unactivecardnum > 0)
            ) {
                sessionStorage.setItem("alreadyread", _y + ",5");
                Vue.prototype
                    .$confirm(
                        "您还有" + info.unactivecardnum + "张银行卡未激活，请前往激活。",
                        "银行卡信息提示",
                        {
                            confirmButtonText: "前往",
                            cancelButtonText: _f ? "继续访问" : "返回",
                            type: "warning",
                            customClass: "info-check"
                        }
                    )
                    .then(() => {
                        next({
                            name: "bank"
                        });
                    })
                    .catch(() => {
                        if (_f) {
                            next();
                        } else {
                            next(false);
                        }
                    });
                return false;
            } /* else if (info.needOcrUpload === "1" && (to.path !== "/fund/sellfund" && to.path !== "/fund/ordersell" && to.path !== "/currencyfund/currencyredemption"
                    && to.path !== "/fund" && to.path !== "/cfund" && to.path !== "/fund/buyfund" && to.path !== "/fund/changefund" && to.path !== "/gfund/generalbuy"
                )) {
                    /!* if(_y.indexOf("3") === -1 || !_f){
                        const _n = _y.indexOf("3") === -1 ? (_y + ",3") : _y;
                        sessionStorage.setItem("alreadyread",_n);
                        initCheck2(_check, next, _f);
                    } *!/
                    if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                        setTimeout(function(){initCheck2(_check, next, _f);}, 1500);
                    } else {
                        initCheck2(_check, next, _f);
                    }
                    if (!_f) {
                        return false;
                    }
                } else if (info.needOcrUpload === "2" && (!sessionStorage.getItem("ocropen") || JSON.parse(sessionStorage.getItem("_a")).token !== sessionStorage.getItem("ocropen")) && (to.path !== "/fund/sellfund" && to.path !== "/fund/ordersell" && to.path !== "/currencyfund/currencyredemption"

                )) {
                    /!* 针对ocr开关登录后提示和只提示一次的情况 *!/
                    sessionStorage.setItem("ocropen", JSON.parse(sessionStorage.getItem("_a")).token);
                    /!* if(_y.indexOf("3") === -1 || !_f){
                        sessionStorage.setItem("alreadyread",(_y.indexOf("3") === -1 ? (_y + ",3") : _y));
                        initCheck2(_check, next, _f);
                    } *!/
                    if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                        setTimeout(function(){initCheck2(_check, next, _f);}, 1500);
                    } else {
                        initCheck2(_check, next, _f);
                    }
                    if (!_f) {
                        return false;
                    }
                } */ else if (
                _check.length > 0 &&
                to.path.indexOf("checkacct") === -1 &&
                !(
                    to.path.indexOf("/fund/sellfund") === 0 ||
                    to.path.indexOf("/currencyfund/currencyredemption") === 0
                )
            ) {
                // 买入类业务（checkCate含"3"）且存在风险测评问题，弹专属弹窗直接跳转风险测评页
                const _riskCheck = _check.find((item) => item.id === "0201");
                const _otherCheck = _check.filter((item) => item.id !== "0201");
                if (!_f && _riskCheck) {
                    const _riskText = _riskCheck.text || "您还未做风险评测或评测已过期，请先完善";
                    Vue.prototype
                        .$confirm(_riskText, "风险评测提示", {
                            confirmButtonText: "去测评",
                            cancelButtonText: "取消",
                            type: "warning",
                            customClass: "info-check"
                        })
                        .then(() => {
                            next({ name: "risktest" });
                        })
                        .catch(() => {});
                    return false;
                }
                const _checkTarget = _riskCheck ? _otherCheck : _check;
                let _showedUserInfoAlert = false;
                if (_checkTarget.length > 0) {
                    if (_y.indexOf("4") === -1 || !_f) {
                        sessionStorage.setItem(
                            "alreadyread",
                            _y.indexOf("4") === -1 ? _y + ",4" : _y
                        );
                        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
                            setTimeout(function () {
                                initCheck(_checkTarget, next, _f);
                            }, 1500);
                        } else {
                            initCheck(_checkTarget, next, _f);
                        }
                        _showedUserInfoAlert = true;
                    }
                }
                // checkCate 仅含「2」时 _f 为 true，若此处仍 return true，会先进入首页等页面并触发首页引导队列（含上传证件照），与「信息完善」MessageBox 叠弹
                if (!_f || _showedUserInfoAlert) {
                    return false;
                }
            }
        }
        return true;
    },
    /* 用户未处理信息获取
 @inParam [Object] info 用户信息
 @inParam [String] cate 是否获取额外用户未完善信息
 @return [Array] 处理后的数据
 */
    acctStatus(info, cate) {
        return userCheck(info, cate);
    },
    /* 获取专业投资者信息
 @inParam [callback] cb 是否获取额外用户未完善信息
 */
    async getProfession(cb) {
        // this.request("acct/info/profession").then((res) => {
        //     if (res.data) {
        //         if (cb) {
        //             cb.call(this, res.data[0] || "");
        //         }
        //     }
        // });
        if (!cache.getBinded()) {
            Vue.prototype.$belongToDialog();
            return;
        }
        const res = await userApi.acctProfessionalInfo();
        if (res.data) {
            if (cb) {
                cb.call(this, res.data[0] || {});
            }
        }
    },
    /* 金额过滤处理
  @inParam [String] val 金额原数据
  @return [Array] 金额处理后数据
  */
    checkAmount(val) {
        const regStr = [
            ["^0(\\d+)$", "$1"], // 禁止录入整数部分两位以上，但首位为0
            ["[^\\d\\.]+$", ""], // 禁止录入任何非数字和点
            ["\\.(\\d?)\\.+", ".$1"], // 禁止录入两个以上的点
            ["^(\\d+\\.\\d{2}).+", "$1"] // 禁止录入小数点后两位以上
        ];
        for (let i = 0; i < regStr.length; i++) {
            const reg = new RegExp(regStr[i][0]);
            val = val.replace(reg, regStr[i][1]);
        }
        return val;
    },
    /* 校验表单查询密码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateQryPwd(rule, value, callback) {
        const msg = checkSameChar(value, "1");
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单登录密码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validatePwd(rule, value, callback) {
        const msg = checkSameChar(value);
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单交易密码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateTPwd(rule, value, callback) {
        const msg = checkSameChar(value, true);
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单图片验证码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateImgVerifyCode(rule, value, callback) {
        const msg = checkVerifyCode(value);
        if (msg) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验表单验证码信息
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateVerifyCode(rule, value, callback) {
        // 10103006 表示验证码长度（与短信验证码输入框 maxlength 同义），仅允许 1-6 的整数，非法值兜底为 6
        const raw = Number(cache.getSysParam("10103006"));
        const codeLength = Number.isInteger(raw) && raw >= 1 && raw <= 6 ? raw : 6;
        const tip = `验证码应为${codeLength}位数字`;
        if (value === "") {
            callback(new Error("请输入验证码"));
        } else {
            const reg = new RegExp(`^[0-9]{${codeLength}}$`);
            if (reg.test(value)) {
                callback();
            } else {
                callback(new Error(tip));
            }
        }
    },
    /* 校验输入金额小数位数
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateDecimal(rule, value, callback) {
        const reg = /^\d+(\.\d{1,2})?$/;
        if (value !== "" && !reg.test(value)) {
            callback(new Error("不能输入超过两位小数"));
        } else {
            if (value !== "") {
                callback();
            } else {
                callback(new Error("请输入" + rule.mes));
            }
        }
    },
    /* 校验输入金额区间
	@inParam [Object] _this VUE实例对象
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateAmountLimit(_this, rule, value, callback) {
        if (this.isEmpty(_this.limit.min)) {
            _this.limit.min = 0;
        }
        if (this.isEmpty(_this.limit.max)) {
            _this.limit.max = 0;
        }
        if (
            Number(value) >= Number(_this.limit.min) &&
            Number(value) <= Number(_this.limit.max) &&
            Number(value) != 0
        ) {
            this.validateDecimal(rule, value, callback);
        } else {
            callback(
                new Error(
                    Number(_this.limit.min) < Number(_this.limit.max)
                        ? _this.limit.text + fmtNum(_this.limit.min) + "-" + fmtNum(_this.limit.max)
                        : "输入范围不符合要求"
                )
            );
        }
    },
    /* 校验输入整数金额区间
	@inParam [Object] _this VUE实例对象
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateIntegerAmountLimit(_this, rule, value, callback) {
        if (this.isEmpty(_this.limit.min)) {
            _this.limit.min = 0;
        }
        if (this.isEmpty(_this.limit.max)) {
            _this.limit.max = 0;
        }
        if (
            Number(value) >= Number(_this.limit.min) &&
            Number(value) <= Number(_this.limit.max) &&
            Number(value) != 0
        ) {
            this.validateDecimal(rule, value, callback);
        } else {
            callback(
                new Error(
                    Number(_this.limit.min) < Number(_this.limit.max)
                        ? _this.limit.text +
                          fmtNum(_this.limit.min, 0) +
                          "-" +
                          fmtNum(_this.limit.max, 0)
                        : "输入范围不符合要求"
                )
            );
        }
    },
    /* 校验单个复选框是否选中
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	@inParam [String] msg 提示信息
	*/
    validateProtocol(rule, value, callback, msg) {
        if (!value) {
            callback(new Error(msg));
        } else {
            callback();
        }
    },
    /* 校验证件号码
   @inParam [Object] rule 校验规则信息
   @inParam [String] value 获取到的校验项值
   @inParam [Object] callback 校验后回调函数
   @inParam [String] certType 证件类型
   */
    validateCertNo(rule, value, callback, certType, needFlag) {
        if (certType === "00" || certType === "05") {
            const _x = checkIdCard(value);
            if (value.includes("*")) {
                // 回显显示脱敏直接通过
                callback();
            } else if (!_x) {
                callback(new Error("身份证号码不正确"));
            } else {
                if (needFlag) {
                    return true;
                } else {
                    callback();
                }
            }
        } else if (certType === "0B") {
            let ereg = "";
            if (value.length !== 15 && value.length !== 18) {
                callback(new Error("请输入正确长度的永居证号码"));
            } else if (value.includes("*")) {
                // 回显显示脱敏直接通过
                callback();
            } else if (value.length === 15) {
                let year1900 =
                    (parseInt(value.substr(7, 2)) + 1900) % 4 == 0 ||
                    ((parseInt(value.substr(7, 2)) + 1900) % 100 == 0 &&
                        (parseInt(value.substr(7, 2)) + 1900) % 4 == 0);
                let year2000 =
                    (parseInt(value.substr(7, 2)) + 2000) % 4 == 0 ||
                    ((parseInt(value.substr(7, 2)) + 2000) % 100 == 0 &&
                        (parseInt(value.substr(7, 2)) + 2000) % 4 == 0);
                if (year1900 || year2000) {
                    ereg =
                        /^[A-Z]{3}[0-9]{4}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{2}$/; // 测试出生日期的合法性
                } else {
                    ereg =
                        /^[A-Z]{3}[0-9]{4}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{2}$/; // 测试出生日期的合法性
                }
                if (!ereg.test(value)) {
                    callback(new Error("永居证号码校验错误"));
                    return;
                }
                // 校验最后一位
                let weight = [7, 3, 1, 7, 3, 1, 7, 3, 1, 7, 3, 1, 7, 3];
                let length = 15 - 1;
                let a = new Array(length);
                let b = new Array(length);
                for (let i = length; i > 0; i--) {
                    if (i > length - 3) {
                        a[length - i] = value.charCodeAt(length - i) - 65 + 10;
                    } else {
                        a[length - i] = value.charCodeAt(length - i) - 48;
                    }
                    b[length - i] = a[length - i] * weight[length - i];
                }
                let sum = 0;
                for (let i = 0; i < b.length; i++) {
                    sum += b[i];
                }
                let mod = sum % 10;
                let checkDigit = value.charCodeAt(length) - 48;
                if (mod !== checkDigit) {
                    callback(new Error("永居证号码校验错误"));
                    return;
                }
                if (needFlag) {
                    return true;
                } else {
                    callback();
                }
            } else if (value.length === 18) {
                let noArray = [];
                noArray = value.split("");
                // 闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
                // 平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
                if (
                    parseInt(value.substr(6, 4)) % 4 == 0 ||
                    (parseInt(value.substr(6, 4)) % 100 == 0 &&
                        parseInt(value.substr(6, 4)) % 4 == 0)
                ) {
                    // mod by caoyy 20181212 解决2000年后出生的身份证校验不合法的问题
                    ereg =
                        /^9[0-9]{5}[1-2][0-9]{3}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/; // 闰年出生日期的合法性正则表达式
                } else {
                    ereg =
                        /^9[0-9]{5}[1-2][0-9]{3}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/; // 平年出生日期的合法性正则表达式
                }
                // 计算校验位
                let S =
                    (parseInt(noArray[0]) + parseInt(noArray[10])) * 7 +
                    (parseInt(noArray[1]) + parseInt(noArray[11])) * 9 +
                    (parseInt(noArray[2]) + parseInt(noArray[12])) * 10 +
                    (parseInt(noArray[3]) + parseInt(noArray[13])) * 5 +
                    (parseInt(noArray[4]) + parseInt(noArray[14])) * 8 +
                    (parseInt(noArray[5]) + parseInt(noArray[15])) * 4 +
                    (parseInt(noArray[6]) + parseInt(noArray[16])) * 2 +
                    parseInt(noArray[7]) * 1 +
                    parseInt(noArray[8]) * 6 +
                    parseInt(noArray[9]) * 3;
                let Y = S % 11;
                let M = "F";
                let JYM = "10X98765432";
                M = JYM.substr(Y, 1); // 判断校验位
                if (M != noArray[17]) {
                    callback(new Error("永居证号码校验错误"));
                    return;
                }

                let area = {
                    11: "北京",
                    12: "天津",
                    13: "河北",
                    14: "山西",
                    15: "内蒙古",
                    21: "辽宁",
                    22: "吉林",
                    23: "黑龙江",
                    31: "上海",
                    32: "江苏",
                    33: "浙江",
                    34: "安徽",
                    35: "福建",
                    36: "江西",
                    37: "山东",
                    41: "河南",
                    42: "湖北",
                    43: "湖南",
                    44: "广东",
                    45: "广西",
                    46: "海南",
                    50: "重庆",
                    51: "四川",
                    52: "贵州",
                    53: "云南",
                    54: "西藏",
                    61: "陕西",
                    62: "甘肃",
                    63: "青海",
                    64: "宁夏",
                    65: "新疆",
                    71: "台湾",
                    81: "香港",
                    82: "澳门",
                    91: "国外"
                };
                if (area[parseInt(value.substr(1, 2))] == null) {
                    callback(new Error("永居证地区非法"));
                    return; // 永居证地区非法
                }
                if (needFlag) {
                    return true;
                } else {
                    callback();
                }
            }
        } else {
            const reg = /^[a-zA-Z0-9\u4e00-\u9fa5（）()-]{4,20}$/g;
            if (reg.test(value) && this.widthCheck(value, 30)) {
                if (needFlag) {
                    return true;
                } else {
                    callback();
                }
            } else if (value.includes("*")) {
                // 回显显示脱敏直接通过
                callback();
            } else {
                callback(new Error("证件号为4-20个字节的数字、字母或中文组合"));
            }
        }
    },
    widthCheck(value, len) {
        let temp = 0;
        let i = 0;
        let charCode = "";
        for (i = 0; i < value.length; i++) {
            charCode = value.charCodeAt(i);
            if (charCode <= 0x007f) {
                temp += 1;
            } else if (charCode <= 0x07ff) {
                temp += 2;
            } else if (charCode <= 0xffff) {
                temp += 3;
            } else {
                temp += 4;
            }
            if (temp > len) {
                return false;
            }
        }
        return true;
    },
    /* 校验银行卡号码
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateBankNum(rule, value, callback) {
        const reg = /^[0-9]{8,20}$/g;
        if (reg.test(value)) {
            callback();
        } else {
            callback(new Error("银行卡号只能为8-20位数字"));
        }
    },
    /* 校验姓名
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateName(rule, value, callback, certType) {
        const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·]{2,40}$/;
        const regLetter = /^[a-zA-Z\s]{2,60}$/;
        if (value === "") {
            callback(new Error("姓名不能为空"));
            return;
        }
        if (certType === "0B" && getBLen(value) > 46) {
            callback(new Error("永居证姓名不能超过46个字符"));
            return;
        }
        if ((reg.test(value) && getBLen(value) < 80) || regLetter.test(value)) {
            callback();
        } else {
            callback(new Error("姓名长度为2-40位中文或2-60位字母"));
        }
    },
    /* 校验输入内容是否仅为字母、中文及分割点
   @inParam [Object] rule 校验规则信息
   @inParam [String] value 获取到的校验项值
   @inParam [Object] callback 校验后回调函数
   @inParam [String] mes 校验表单信息
   */
    validateGeneral(rule, value, callback, mes) {
        if (value === "") {
            callback(new Error(mes + "输入不能为空"));
        }
        const reg = /^[a-zA-Z\u4e00-\u9fa5·]{2,20}$/g;
        if (!reg.test(value)) {
            callback(new Error(mes + "输入数据不规范"));
        } else {
            callback();
        }
    },
    /* 校验姓名
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateBankName(rule, value, callback) {
        const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s()a-zA-Z\d]{2,40}$/;
        if (!reg.test(value)) {
            callback(new Error("开户行名称长度为4-40位"));
        }
        callback();
    },
    /* 校验日期
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateDate(rule, value, callback) {
        value = value.replace(/(^\s*)|(\s*$)/g, "");
        if (value) {
            callback();
        } else {
            callback(new Error("请输入日期"));
        }
    },
    /* 校验是否为中英文字母及数字
	@inParam [Object] rule 校验规则信息
	@inParam [String] value 获取到的校验项值
	@inParam [Object] callback 校验后回调函数
	*/
    validateCCharacter(rule, value, callback) {
        const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
        if (!reg.test(value)) {
            callback(new Error("只能输入汉字、英文字母及数字"));
        } else {
            callback();
        }
    },
    /* 获取验证码图片地址
   @inParam [Object] 组装url参数
   @return [String] 组装后的url
   */
    async imgUrl(biztype = Vue.prototype.$const.IMG_BIZTYPE.OTHER) {
        const params = Object.assign({
            width: "112",
            height: "38",
            count: 4,
            x: Math.random(),
            biztype
        });
        return userApi.getAuthCode(params);
    },
    /* 查询页面协议信息
	@inParam [String] type 协议类型
	@return [Object] Promise
	@Promise-then [Array] 查询到的协议数据结果集
	*/
    getProtocol(type, fundshowtype = "", policytype = "") {
        if (!type && !policytype) return;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            const res = await fundApi.getProtocol({
                // policytype: type,
                scene: type,
                fundtype: fundshowtype,
                policytype: policytype
            });
            if (res.data) {
                res.data = res.data.map((item) => {
                    return {
                        ...item,
                        querytype: type,
                        isAgreement: true
                    };
                });
                resolve(res.data);
            } else {
                reject(res);
            }
            // req({
            //     method: "GET",
            //     url: "/common/protocol",
            //     params: {
            //         type: type,
            //     },
            // })
            //     .then((res) => {
            //         const returnData = res.record[0];
            //         resolve(returnData);
            //     })
            //     .catch((err) => reject(err));
        });
    },
    /* 查询风险页面协议信息
	@inParam [String] type 协议类型
	@return [Object] Promise
	@Promise-then [Array] 查询到的协议数据结果集
	*/
    getRiskProtocol(type) {
        if (!type) return;
        return new Promise((resolve, reject) => {
            req({
                method: "GET",
                url: "common/sdx",
                params: {
                    type: type
                }
            })
                .then((res) => {
                    if (res.code === "0000000") {
                        const returnData = res.record[0][0] ? res.record[0][0].content : "";
                        resolve(returnData);
                    }
                })
                .catch((err) => reject(err));
        });
    },
    /**
     * 数字格式化千分位
     * @param {string | number} num 格式化数字 必填
     * @param {number} precision 保留小数位数 默认2
     * @param {boolean} rounding 是否四舍五入 默认true
     */
    fmtNum,
    /**
     * 数字格式化百分数
     * @param {string | number} num 格式化数字 必填
     * @param {number} precision 保留小数位数 默认2
     */
    fmtToPercent,
    toThousands,
    /* 生成图片src的url（追加/api/v1前缀, 添加公参）
	@inParam [String] url
	@inParam [Object] 参数对象。注意url参数必须放在这里，不允许以查询串的形式直接跟在第一个参数url中
	@return [String] 加工后的url
	*/
    src(url, params, flag) {
        params = Object.assign(params || {}, {
            token: cache.getSessionToken(),
            g_systemtype: conf.systemtype
        });
        let queryStr = "?";
        for (let prop in params) {
            queryStr += prop + "=" + encodeURIComponent(params[prop]) + "&";
        }
        queryStr = queryStr.substring(0, queryStr.length - 1);
        return (!flag ? conf.api.baseUrl : "") + url + queryStr;
    },
    /* 打开一个新页面，用于跳转银行卡页面鉴权
	@inParam [String] bankUrl 银行接口返回银行鉴权地址
	*/
    newWinOpen(bankUrl) {
        const getRootPath = function () {
            return window.location.protocol + "//" + window.location.host + conf.api.bankUrl;
        };
        let openUrl = getRootPath() + "/img/bank.html?bankUrl=" + bankUrl;
        window.open(openUrl);
    },
    // url要跳转到的页面，data要传递的数据，name显示方式
    openPostWindow(url, data, method, name) {
        const tempForm = document.createElement("form");
        tempForm.id = "tempForm";
        tempForm.enctype = "multipart/form-data";
        tempForm.method = method;
        tempForm.action = url;
        tempForm.target = name;
        for (const item in data) {
            const hideInput = document.createElement("input");
            hideInput.type = "hidden";
            hideInput.name = item;
            hideInput.value = data[item];
            tempForm.appendChild(hideInput);
        }
        document.body.appendChild(tempForm);
        tempForm.submit();
        document.body.removeChild(tempForm);
    },
    newWinOpenSign(signUrl) {
        const getRootPath = function () {
            return window.location.protocol + "//" + window.location.host + conf.api.bankUrl;
        };
        let openUrl = getRootPath() + "/img/sign.html?signUrl=" + signUrl;
        window.open(openUrl);
    },

    // 针对
    newWinOpenSignPage(signUrl) {
        const getRootPath = function () {
            return window.location.protocol + "//" + window.location.host + conf.api.bankUrl;
        };
        let openUrl = getRootPath() + "/img/signpage.html?signUrl=" + signUrl;
        window.open(openUrl);
    },
    // 敬请期待
    pleaseExpect(_this) {
        _this.$msgbox({
            title: "温馨提示",
            message: _this.$createElement("div", null, [
                _this.$createElement("span", null, "该功能正在开发中，敬请期待！")
            ]),
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    done();
                } else {
                    done();
                }
            }
        });
    },
    /* 页面鉴权获取鉴权信息
	@inParam [Object] param 配置信息
	@inParam [Object] fn 校验后回调函数
	*/
    confirmBankAuth(_this, param, url, fn) {
        param = param || {};
        const h = _this.$createElement;
        let actionName = param.action || "认证";
        if (url === "tradePayAuthentication") {
            actionName = "支付";
        }
        _this
            .$msgbox({
                title: param.title || "银行认证页面",
                message: h("p", null, "请在所弹出的银行页面完成认证操作!"),
                showCancelButton: true,
                confirmButtonText: actionName + "完成",
                cancelButtonText: actionName + "出现问题",
                closeOnClickModal: false,
                roundButton: true
            })
            .then(async (action) => {
                if (action === "confirm") {
                    // if里面为银行卡页面签约鉴权操作时新增的内容，else里为老内容，如果有其他功能用到这块看能不能共用if里的内容，全部处理完再删除else的内容
                    if (url === "BankPageAuthentication") {
                        const msgText = param.isAuthFlag
                            ? "获取鉴权信息失败，请重试"
                            : "获取签约信息失败，请重试";
                        let callRes = "";
                        // 建行网联的回调地址配置在银行那边，需要单独处理
                        if (param.paychannel == "0105" || param.paycenterid == "0105") {
                            callRes = await userApi.qryCcbBankData({});
                        } else {
                            callRes = await userApi.qryBankCallbackInfo({
                                token: param.token
                            });
                        }
                        if (callRes.code == "0" && callRes.body) {
                            param.bankdata = callRes.body.bankdata;
                            let signRes = "";
                            if (param.changeMobileByBank) {
                                // 银行卡修改密码
                                signRes = await userApi.modifyMobileAuthConfirm(
                                    param,
                                    _this.$cache.getIsEncrypted()
                                );
                            } else {
                                if (param.isAuthFlag) {
                                    signRes = await userApi.combVerifyConfirm(
                                        param,
                                        _this.$cache.getIsEncrypted()
                                    );
                                } else {
                                    signRes = await userApi.combSignConfirm(
                                        param,
                                        _this.$cache.getIsEncrypted()
                                    );
                                }
                            }
                            if (signRes.code == "0" && signRes.body) {
                                const message1 = actionName + "完成";
                                // const message2 = "秒后页面跳转";
                                _this.$message({
                                    type: "success",
                                    message: message1,
                                    onClose: function () {
                                        fn();
                                    }
                                });
                            } else {
                                _this.$message.error(msgText);
                            }
                        } else {
                            _this.$message.error(msgText);
                        }
                    } else if (url === "unSignBankPageAuthentication") {
                        let callRes = "";
                        // 建行网联的回调地址配置在银行那边，需要单独处理
                        if (param.paychannel == "0105" || param.paycenterid == "0105") {
                            callRes = await userApi.qryCcbBankData({});
                        } else {
                            callRes = await userApi.qryBankCallbackInfo({
                                token: param.token
                            });
                        }
                        if (callRes.code == "0" && callRes.body) {
                            param.bankdata = callRes.body.bankdata;
                            const signRes = await userApi.combUnSignConfirm(
                                param,
                                _this.$cache.getIsEncrypted()
                            );
                            if (signRes.code == "0" && signRes.body) {
                                const message1 = actionName + "完成";
                                _this.$message({
                                    type: "success",
                                    message: message1,
                                    onClose: function () {
                                        fn();
                                    }
                                });
                            } else {
                                _this.$message.error("获取解约信息失败，请重试");
                            }
                        } else {
                            _this.$message.error("获取解约信息失败，请重试");
                        }
                    } else if (url === "tradePayAuthentication") {
                        let callRes = "";
                        // 建行网联的回调地址配置在银行那边，需要单独处理
                        if (param.paychannel == "0105" || param.paycenterid == "0105") {
                            callRes = await userApi.qryCcbBankData({});
                        } else {
                            callRes = await userApi.qryBankCallbackInfo({
                                token: param.token
                            });
                        }
                        if (callRes.code == "0" && callRes.body) {
                            param.bankdata = callRes.body.bankdata;
                            const payRes = await fundApi.payInform(param);
                            if (payRes.code == "0" && payRes.body) {
                                if (payRes.body.paystatus == "03") {
                                    _this.$message.error("支付失败，请重试");
                                    return;
                                }
                                let message1 = actionName + "完成";
                                if (payRes.body.paystatus == "01") {
                                    message1 = "支付处理中";
                                }
                                _this.$message({
                                    type: "success",
                                    message: message1,
                                    onClose: function () {
                                        fn(message1);
                                    }
                                });
                            } else {
                                _this.$message.error(
                                    "支付状态未明，具体结果请去支付网银查询资金，以银行扣款信息为准！"
                                );
                            }
                        } else {
                            _this.$message.error(
                                "支付状态未明，具体结果请去支付网银查询资金，以银行扣款信息为准！"
                            );
                        }
                    } else {
                        let _x = {
                            method: "GET",
                            url: url,
                            params: {}
                        };
                        req(_x)
                            .then((res) => {
                                if (res.code === "0000000") {
                                    if (
                                        res.record[0][0].status === "1" ||
                                        res.record[0][0].bankbizsuccess === "1"
                                    ) {
                                        const message1 = actionName + "完成，";
                                        const message2 = actionName + "秒后页面跳转";
                                        _this.$handleAutoCloseMessage({
                                            type: "success",
                                            message1: message1,
                                            message2: message2,
                                            number: 3,
                                            onClose: function () {
                                                fn();
                                            }
                                        });
                                    } else {
                                        _this.$message.error("获取鉴权信息失败，请重试");
                                    }
                                } else {
                                    _this.$message.error(res.msg);
                                }
                            })
                            .catch(() => {});
                    }
                } else {
                    return false;
                }
            })
            .catch(() => {
                return false;
            });
    },
    /* 格式化整型日期,仅检查位数和字符有效性，如果无效返回
	@inParam [String] date 可以是Date、int、string类型
	@inParam [String] sSplit 分隔符,默认'-','CN'表示用年月日分隔
	@return [String] 组装后的日期
	*/
    fmtDate(date, sSplit) {
        if (!date) {
            return "--";
        }
        let sDate, sY, sM, sD;
        if (isNaN(date) && !isNaN(Date.parse(date))) {
            sY = date.getFullYear();
            sM = date.getMonth() + 1 + "";
            if (sM.length === 1) {
                sM = "0" + sM;
            }
            sD = date.getDate() + "";
            if (sD.length === 1) {
                sD = "0" + sD;
            }
        } else {
            sDate = date.toString();
            if (/^\d{8}$/.test(sDate)) {
                sY = sDate.substring(0, 4);
                sM = sDate.substring(4, 6);
                sD = sDate.substring(6, 8);
            } else {
                return "--";
            }
        }

        if (sSplit === "CN") {
            sDate = sY + "年" + sM + "月" + sD + "日";
        } else {
            if (sSplit === undefined || sSplit == null) {
                sSplit = "-";
            }
            sDate = sY + sSplit + sM + sSplit + sD;
        }
        return sDate;
    },
    fmtTime(time, sSplit, minute) {
        if (!time) {
            return "--";
        }
        if (time.length !== 6) {
            return time;
        }
        var sH = time.substring(0, 2);
        var sM = time.substring(2, 4);
        var sS = time.substring(4, 6);
        if (sSplit === undefined || sSplit == null) {
            sSplit = ":";
        }
        if (minute) {
            // 精确到分
            return sH + sSplit + sM;
        }
        var sTime = sH + sSplit + sM + sSplit + sS;
        return sTime;
    },
    /* 表单数据校验
	@inParam [Object] _this Vue实例对象
	@inParam [String] formName 校验表单对象名
	@return [String] 函数返回
	*/
    mobileCheck(_this, formName) {
        let mes = "";
        // 处理银行卡找回密码表单数据校验
        if (_this.checkBank || (!_this.hasTranAcct && _this.hasTranAcct !== undefined)) {
            for (const key in _this.pwdForm) {
                if (key !== "mobile" && key !== "verifyCode" && key !== "type") {
                    _this.$refs[formName].validateField(key, function (str) {
                        if (str) {
                            mes = str;
                            return false;
                        }
                    });
                }
            }
        }
        if (mes !== "") {
            return false;
        }
        _this.$refs[formName].validateField("mobile", function (str) {
            if (str === "") {
                if (_this.checkBank || (!_this.hasTranAcct && _this.hasTranAcct !== undefined)) {
                    _this.sendBank();
                } else {
                    _this.dialogVisible = true;
                }
            } else {
                return false;
            }
        });
    },
    /* 按钮读秒倒计时
	@inParam [Object] _this Vue实例对象
	@inParam [Object] fn 回调函数
	@inParam [String] text 回调函数
	*/
    btnDisabled(_this, fn, text) {
        if (_this.time === 0) {
            clearInterval(setTime);
            return;
        }
        setTime = setInterval(function () {
            _this.time--;
            _this.btnMsg = "等待" + _this.time + "秒";
            if (_this.time === 0 || _this.time === undefined) {
                clearInterval(setTime);
                _this.btnMsg = text || "获取验证码";
                if (fn) {
                    fn.call(this, _this);
                }
            }
        }, 1000);
    },
    /* 发送短信验证码
	@inParam [Object] _this Vue实例对象
	@inParam [String] val 图片验证码值
	@inParam [String] formName 校验表单对象名
	@inParam [String] url 访问链接
	*/
    sendSms(_this, val, formName, url) {
        _this.dialogVisible = false;
        let data = {
            mobile: _this[formName].mobile,
            verifycode: val
        };
        req({ method: "POST", url: url, data: data })
            .then((res) => {
                if (res.code === "0000000") {
                    /* 倒计时 */
                    _this.time = res.record[0][0].sendperiod;
                    _this.locked = true;
                    _this.$util.btnDisabled(_this);
                } else {
                    _this.$message({
                        type: "warning",
                        message: res.msg
                    });
                }
            })
            .catch(() => {});
    },
    /* 请求封装
	@inParam [String] url 请求地址
	@inParam [Object] data 请求入参
	@inParam [Boolean] way get或post请求，默认get
	@inParam [Boolean] loader 是否显示局部加载图标
	@Promise-then [Array] 查询到的数据结果集
	*/
    request(url, data, way, loader, blob) {
        const method = !way || way === "GET" ? "GET" : way;
        // 处理特殊情况两个相同请求需要同时发送，在url后面加&
        const repeat = url.indexOf("&") > -1;
        url = url.replace(/&/, "");
        data = data || {};
        // 加载区域配置
        // loader: {
        //   target: '.login-panel'
        // }
        let param = {
            method: method,
            url: url,
            loader: loader,
            repeat: repeat
        };
        // 针对文件下载设置文件流格式
        if (blob) param.responseType = "arraybuffer";

        if (method === "GET" || method === "DELETE") {
            param.params = data;
        } else {
            param.data = data;
        }
        return new Promise((resolve, reject) => {
            if (this.isV5Api(url)) {
                httpClient
                    .request(param)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            } else {
                req(param)
                    .then((res) => {
                        let returnData = {
                            msg: res.msg
                        };
                        if (res.code === "0000000") {
                            const _x = res.record.length > 1 ? res.record : res.record[0];
                            if (res.alllength) {
                                returnData.alllength = res.alllength;
                            }
                            returnData.data = _x;
                        }
                        resolve(returnData);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            }
        });
    },
    /**
     * 判断是否为5.0的api
     * @param {*} url
     * @returns
     */
    isV5Api(url) {
        const v5ApiKeys = Object.keys(urls);
        for (let i = 0; i < v5ApiKeys.length; i++) {
            const key = v5ApiKeys[i];
            const value = urls[key];
            if (value == url) {
                return true;
            }
        }
        return false;
    },
    /* 加载图片
	@inParam [String] id 图片id
	@return [String] 组合图片地址
	*/
    getImg(id) {
        try {
            return require("../../public/bankImg/" + id + ".png");
        } catch (e) {
            return require("../../public/bankImg/" + "yhk" + ".png");
        }
    },
    /* 获取下拉银行卡列表信息
	@inParam [String] url 获取银行卡链接
	@inParam [Function] cb 回调函数
	*/
    getBank(url, cb) {
        this.request(url).then((res) => {
            let _obj = {
                bank: [],
                other: {}
            };
            if (res.data) {
                _obj.bank = this.getBankArr(res.data[0]);
                // 处理其他结果集信息
                if (res.data[1]) {
                    _obj.other = res.data[1][0];
                }
            }
            // 返回银行卡数据
            if (cb) {
                cb.call(this, _obj);
            }
        });
    },
    /* 获取获取银行卡网点列表信息并特殊处理用于列表展示
	@inParam [Function] cb 回调函数
	*/
    async getBankInfo(params, cb) {
        const res = await userApi.qryAddableBankList({
            biztype: params.biztype2 ? params.biztype2 : "add-multi"
        });
        if (res.data.bankList) {
            const _arr = JSON.parse(JSON.stringify(res.data.bankList));
            const _arr8 = JSON.parse(JSON.stringify(res.data.bankList)).filter(
                (item) => item.businessflag && item.businessflag.indexOf("8") > -1
            );
            const bank = getBankInfoFunc(_arr, params);
            const bank8 = getBankInfoFunc(_arr8, params);
            // 返回银行卡数据
            if (cb) {
                cb.call(this, bank, bank8);
            }
        }
    },
    /* 组装下拉银行卡列表信息
	 @inParam [Array] bankArr 需要组装的银行卡信息
	 @return [String] 组装后的银行卡信息
	*/
    getBankArr(bankArr, hk) {
        const _y = bankArr;
        hk = hk || "";
        // 初始化银行卡信息
        let bankLists = [
            {
                label: "",
                options: [
                    {
                        value: "",
                        bankAdd: "添加银行卡",
                        bankCate: "你还没有可用银行卡",
                        label: ""
                    }
                ]
            }
        ];
        if (_y && _y.length > 0) {
            let _x = {};
            for (let i in _y) {
                if (_y[i].hkcardflag && hk && _y[i].hkcardflag !== "1") {
                    continue;
                }
                if (_y[i].zxcardflag && !hk && _y[i].zxcardflag !== "1") {
                    continue;
                }
                let _z = {};
                _z.value = _y[i].channelid;
                _z.paycenterid = _y[i].paycenterid;
                _z.bankcode = _y[i].bankcode;
                _z.biztype = _y[i].biztype;
                _z.transactionaccountid = _y[i].transid || _y[i].transactionaccountid;
                _z.bankcardid = _y[i].bankcardid;
                _z.paytype = _y[i].paytype;
                _z.netnominbuy = _y[i].netnominbuy;
                _z.netnomaxbuy = _y[i].netnomaxbuy;
                _z.discountrate = _y[i].discountrate;
                // 处理天天盈渠道
                if (_y[i].channelid === conf.const.TTY_CHANLEID) {
                    _z.bankid = "TTY";
                }
                _z.text =
                    _y[i].remark && _y[i].remark.trim()
                        ? "限额：" + (hk ? "不限额" : _y[i].remark)
                        : "";
                _z.label =
                    this.getChannelName(_y[i]) +
                    "(" +
                    this.lastFour([
                        _y[i].desendepositcard,
                        _y[i].depositcardproc,
                        _y[i].desendepositcard,
                        _y[i].rawdepositcard,
                        _y[i].depositcard
                    ]) +
                    ")";
                _z.mobile = _y[i].mobile;
                if (!_x[_y[i].paycenterid]) {
                    _x[_y[i].paycenterid] = {};
                    _x[_y[i].paycenterid].label = _y[i].paycentername;
                    _x[_y[i].paycenterid].options = [];
                }
                _x[_y[i].paycenterid].options.push(_z);
            }
            let _index = 0;
            for (let list in _x) {
                if (_index === 0) {
                    bankLists[0].options[0].bankCate = _x[list].label;
                    bankLists[0].options = bankLists[0].options.concat(_x[list].options);
                    _index++;
                } else {
                    bankLists.push(_x[list]);
                }
            }
            if (bankLists.length === 1 && bankLists[0].options.length === 1) {
                bankLists = [];
            }
        }
        return bankLists;
    },
    // 获取不区分支付渠道的银行卡信息
    getBankListsOfR(bankLists) {
        let arr = [];
        let indexSum = 0;
        bankLists.forEach((item, index) => {
            item.options.forEach((item1, index1) => {
                arr[indexSum] = {};
                if (item1.bankAdd == "添加银行卡") {
                    arr[indexSum].bankAdd = "添加银行卡";
                }
                let str = item1.label.split("（")[1];
                let card = str ? str.split("）")[0] : "";
                arr[indexSum].bankid_card =
                    item1.bankAdd == "添加银行卡" ? "" : item1.bankcode + "_" + card;
                arr[indexSum].label =
                    item1.label.split("-").length === 1 ? item1.label : item1.label.split("-")[1];
                arr[indexSum].bankcardid = item1.bankcardid;
                arr[indexSum].text = item1.text || "";
                arr[indexSum].biztype = item1.biztype;
                indexSum++;
            });
        });
        //  去重
        let res = new Map();
        return arr.filter(
            (item) => !res.has(item["bankid_card"]) && res.set(item["bankid_card"], 1)
        );
    },

    /* 提取对象某些值生成一个新对象
   @inParam [Object] obj 原对象
   @inParam [String] str 需要提取的参数，以逗号隔开
   @return [Object] 处理后的对象
   */
    getObjParam(obj, str) {
        if (str.toString() && str.indexOf(",") > -1) {
            const arr = str.split(",");
            let _obj = {};
            for (let i = 0; i < arr.length; i++) {
                _obj[arr[i]] = obj[arr[i]] || "";
            }
            return _obj;
        } else {
            return {
                str: obj[str] || ""
            };
        }
    },
    /* 根据传入的某个字段合并成一个新数组，并可以根据需要对里面的某些字段求和或以逗号隔开处理
   @param [Array] fundLists 原数组信息
   @param [Object] oparams 合并依赖和计算合并字段{code:'合并字段', noFilter:'不需要合并判断字段', noFilterVal:'不需要合并判断字段值', data:['求和字段','']}
   @param [Boolean] str 合并字段是否以逗号隔开
   @returns [Array] 返回合并后数据列表
   */
    getCodeOnly(fundLists, oparams, str) {
        let fundList = [];
        let temp = {};
        for (let i = 0; i < fundLists.length; i++) {
            let tempList = Object.assign({}, fundLists[i]);
            // 处理特殊数据
            if (oparams.noFilter && tempList[oparams.noFilter] === oparams.noFilterVal) {
                tempList.fundArr = [];
                tempList.fundArr.push(fundLists[i]);
                fundList.push(tempList);
                continue;
            }
            // 数据合并
            // 添加第一条数据
            if (!temp[tempList[oparams.code]] || !tempList[oparams.code].trim()) {
                temp[tempList[oparams.code]] = true;
                tempList.fundArr = [];
                tempList.fundArr.push(fundLists[i]);
                fundList.push(tempList);
            } else {
                // 合并其它相同数据
                for (let j in fundList) {
                    if (fundList[j][oparams.code] === tempList[oparams.code]) {
                        if (oparams.data && oparams.data.length > 0) {
                            const _m = Math.pow(10, 4);
                            for (let l = 0; l < oparams.data.length; l++) {
                                if (!str) {
                                    fundList[j][oparams.data[l]] =
                                        Math.round(
                                            (Number(fundList[j][oparams.data[l]]) +
                                                Number(fundLists[i][oparams.data[l]])) *
                                                _m
                                        ) / _m;
                                } else {
                                    if (fundLists[i][oparams.data[l]]) {
                                        if (fundList[j][oparams.data[l]]) {
                                            fundList[j][oparams.data[l]] +=
                                                "," + fundLists[i][oparams.data[l]];
                                        } else {
                                            fundList[j][oparams.data[l]] =
                                                fundLists[i][oparams.data[l]];
                                        }
                                    }
                                }
                            }
                        }
                        fundList[j].fundArr.push(tempList);
                        break;
                    }
                }
            }
        }
        return fundList;
    },
    /* 判断基金是否可以购买
   @param [String] status 基金状态信息
   @returns [String] 返回判断信息
   */
    checkBuy(fund) {
        if (fund.assetshowtype && fund.assetshowtype == "1" && !Vue.prototype.$util.xjbIsOpen()) {
            return "系统未开通现金宝服务";
        }
        if (fund.publishstatus && fund.publishstatus != "1") {
            return "基金状态为未发布";
        }
        // 专户基金校验：若不允许网上交易，则不能购买
        if (
            fund.fundshowtype === "8" &&
            (this.isEmpty(fund.tradingmethod) || fund.tradingmethod.indexOf(conf.systemtype) < 0)
        ) {
            return "该专户基金不属于网上交易产品";
        }
        if (fund.tradingmethod && fund.tradingmethod.indexOf(conf.systemtype) < 0) {
            return "该基金不属于网上交易产品";
        }
        if (fund.ispostponetaxfund == "1") {
            return "暂不支持购买个税递延产品";
        }
        if (fund.status === CommonConst.FS_OnIssue) {
            return "";
        }
        if (
            fund.status === CommonConst.FS_OnTrade ||
            fund.status === CommonConst.FS_OffRedeem ||
            fund.status === CommonConst.FS_OnSetBal
        ) {
            return "";
        } else {
            return "基金状态为" + cache.getDict("130011", fund.status);
        }
    },
    /* 判断组合基金是否可以购买
   @param [String] status 组合基金状态信息
   @returns [String] 返回判断信息
   */
    checkComboBuy(status) {
        const temp = [
            CommonConst.FS_OnIssue,
            CommonConst.FS_IssueSucc,
            CommonConst.FS_IssueFail,
            CommonConst.FS_OffTrade,
            CommonConst.FS_OffBid,
            CommonConst.FS_CloseFund,
            CommonConst.FS_EndFund
        ];
        let canPurchase = true;
        let _x = "";
        for (let i in temp) {
            if (status.indexOf(temp[i]) > -1) {
                canPurchase = false;
                _x = temp[i];
                break;
            }
        }
        if (canPurchase) {
            return "";
        } else {
            return "组合当中包含状态为" + cache.getDict("130011", _x) + "的基金";
        }
    },
    /* 判断组合基金是否可以定投
   @param [String] fund 组合基金信息
   @returns [String] 返回判断信息
   */
    checkComboGeneral(fund) {
        const temp = [
            CommonConst.FS_OnIssue,
            CommonConst.FS_IssueFail,
            CommonConst.FS_OffTrade,
            CommonConst.FS_IssueSucc,
            CommonConst.FS_CloseFund,
            CommonConst.FS_EndFund
        ];
        let canPurchase = true;
        let _x = "";
        for (let i in temp) {
            if (fund.fundstatus.indexOf(temp[i]) > -1) {
                canPurchase = false;
                _x = temp[i];
                break;
            }
        }
        if (canPurchase) {
            for (let j in fund.fundArr) {
                if (fund.fundArr[j].fundbizflag.indexOf("1") === -1) {
                    canPurchase = false;
                    return "组合当中存在基金未开通定期定额交易手段";
                }
            }
            return "";
        } else {
            return "组合当中包含状态为" + cache.getDict("130011", _x) + "的基金";
        }
    },
    /* 判断基金是否可以定投
   @param [String] fund 组合基金信息
   @returns [String] 返回判断信息
   */
    checkGeneral(fund) {
        if (fund.assetshowtype && fund.assetshowtype == "1" && !Vue.prototype.$util.xjbIsOpen()) {
            return "系统未开通现金宝服务";
        }
        if (fund.publishstatus && fund.publishstatus != "1") {
            return "基金状态为未发布";
        }
        if (
            fund.fundshowtype === "8" &&
            (this.isEmpty(fund.tradingmethod) || fund.tradingmethod.indexOf(conf.systemtype) < 0)
        ) {
            return "该专户基金不属于网上交易产品";
        }

        if (fund.tradingmethod && fund.tradingmethod.indexOf(conf.systemtype) < 0) {
            return "该基金不属于网上交易产品";
        }
        if (fund.ispostponetaxfund == "1") {
            return "暂不支持购买个税递延产品";
        }
        if (fund.valuagrbuystate && fund.valuagrbuystate.indexOf("1") > -1) {
            const status = fund.status;
            if (
                status === CommonConst.FS_OnIssue ||
                status === CommonConst.FS_IssueFail ||
                status === CommonConst.FS_OffTrade ||
                status === CommonConst.FS_CloseFund ||
                status === CommonConst.FS_EndFund ||
                status === CommonConst.FS_IssueSucc
            ) {
                return "基金状态为" + cache.getDict("130011", status);
            } else {
                return "";
            }
        } else {
            return "基金未开通定期定额交易手段";
        }
    },
    /* 判断基金是否可以预约购买
   @param [String] fund 基金信息
   @returns [String] 返回判断信息
   */
    checkOrderBuy(fund) {
        const status = fund.status;
        if (status === CommonConst.FS_OnTrade || status === CommonConst.FS_OffRedeem) {
            return "";
        } else {
            return "基金状态为" + cache.getDict("130011", status);
        }
    },
    /* 判断基金是否可以预约赎回
   @param [String] fund 基金信息
   @returns [String] 返回判断信息
   */
    checkOrderSell(fund) {
        const status = fund.fundstatus;
        if (status === CommonConst.FS_OnTrade || status === CommonConst.FS_OffBid) {
            return "";
        } else {
            return "基金状态为" + cache.getDict("130011", status);
        }
    },
    /* 判断基金是否可以赎回
  @param [Object] obj 原数组信息
  @returns [String] 返回判断信息
  */
    checkSell2(obj) {
        // 此逻辑是之前的先保留验证新的
        let t = ",不能赎回";
        if (obj.assetshowtype && obj.assetshowtype == "1" && !Vue.prototype.$util.xjbIsOpen()) {
            return "系统未开通现金宝服务，不能赎回";
        }

        // 线下份额让赎不让转
        // if (
        //     obj.fundArr &&
        //     obj.fundArr.every(
        //         (item) => item.paycenterid === conf.const.ZX_CENTER || item.paycenterid === "0001"
        //     )
        // ) {
        //     return "直销柜台购买产品需在直销柜台赎回";
        // }

        // 预约赎回不在资产接口里判断份额是否为0
        if (obj.usableremainshare > 0 || obj.bookingredeem == "1") {
            if (obj.fundArr && obj.fundArr.every((item) => item.sourceflag === "2")) {
                return "非直销渠道购买不能赎回";
            }
            const status = obj.fundstatus || obj.status;
            if (status === CommonConst.FS_OnTrade || status === CommonConst.FS_OffBid) {
                return "";
            } else {
                return "基金状态为" + cache.getDict("130011", status) + t;
            }
        } else {
            return "基金可用份额为0" + t;
        }
    },

    checkSell(obj) {
        const t = ",不能赎回";
        // 1. 现金宝校验
        if (obj.assetshowtype === "1" && !Vue.prototype.$util.xjbIsOpen()) {
            return `系统未开通${Vue.prototype.$const.getXJBParam("name")}服务，不能赎回`;
        }
        const fundArr = obj.fundArr || [];
        // 2. 是否存在【直销 + 可用份额】
        const hasDirectUsable = fundArr.some(
            (item) =>
                item.sourceflag === "1" &&
                (Number(item.usableremainshare) > 0 || obj.bookingredeem === "1")
        );

        if (!hasDirectUsable) {
            // 没有任何直销可赎回份额
            if (fundArr.every((item) => item.sourceflag === "2")) {
                return "非直销渠道购买不能赎回";
            }
            return "基金可用份额为0" + t;
        }

        // 专户基金校验：若不允许网上交易，则不能赎回
        if (
            obj.fundshowtype === "8" &&
            (this.isEmpty(obj.tradingmethod) || obj.tradingmethod.indexOf(conf.systemtype) < 0)
        ) {
            return "该专户基金不属于网上交易产品";
        }
        // 3. 基金状态校验
        const status = obj.fundstatus || obj.status;
        if (status === CommonConst.FS_OnTrade || status === CommonConst.FS_OffBid) {
            return "";
        }

        return "基金状态为" + cache.getDict("130011", status) + t;
    },

    /* 判断基金是否可以转换
  @param [Object] obj 原数组信息
  @returns [String] 返回判断信息
  */
    checkChange(obj) {
        if (obj.usableremainshare > 0) {
            // if (obj.sourceflag === "2") {
            //     return "该基金为代销基金";
            // }
            if (obj.fundArr && obj.fundArr.every((item) => item.sourceflag === "2")) {
                return "非直销渠道购买";
            }

            // 线下份额让赎不让转
            // if (
            //     obj.fundArr &&
            //     obj.fundArr.every(
            //         (item) =>
            //             item.paycenterid === conf.const.ZX_CENTER || item.paycenterid === "0001"
            //     )
            // ) {
            //     return "直销柜台购买产品需在直销柜台进行操作";
            // }

            // 专户基金校验：若不允许网上交易，则不能转换（源基金）
            if (
                obj.fundshowtype === "8" &&
                (this.isEmpty(obj.tradingmethod) || obj.tradingmethod.indexOf(conf.systemtype) < 0)
            ) {
                return "该专户基金不属于网上交易产品";
            }

            const status = obj.status;
            if (status === CommonConst.FS_OnTrade || status === CommonConst.FS_OffBid) {
                return "";
            } else {
                return "基金状态为" + cache.getDict("130011", status);
            }
            // if (obj.sharetype === CommonConst.ST_Before) {

            // } else {
            //     return "基金收费方式为后收费";
            // }
        } else {
            return "基金可用份额为0";
        }
    },
    /* 获取产品适当性匹配信息
  @param [Object] _this Vue对象
 @param [Object] fund 待校验基金
 @param [Function] cb 回调方法
 */
    async fundRiskCheck(_this, fund, cb) {
        // 判断用户是否已绑定交易账户
        const info = cache.getUser();
        const custname = info.custname;
        this.getProfession((data) => {
            const _x = Object.assign({}, info, data);
            // 用户名不能从该接口中取
            _x.custname = custname;
            _this.$store.dispatch("setInfo", _x);
            if (
                !cache.getBinded()
                // ||!info.tradingmethod ||
                // info.tradingmethod.indexOf("2") === -1
            ) {
                Vue.prototype
                    .$confirm(
                        "您的账户尚未认证，暂时无法进行购买/定投基金等交易功能，是否立即前往账户认证",
                        "交易手段信息提示",
                        {
                            confirmButtonText: "前往",
                            cancelButtonText: "返回",
                            type: "warning",
                            customClass: "info-check"
                        }
                    )
                    .then(() => {
                        _this.$router.push({
                            name: "bindacctway"
                        });
                    })
                    .catch(() => {});
                return false;
            }

            // 调用新接口查询客户风险等级是否匹配
            // const info = cache.getUser();
            // 转换入口显式跳过此处的转出基金风险匹配，后续由目标基金重新校验。
            if (fund.skipCustRiskMatch) {
                const checkedFund = Object.assign({}, fund);
                delete checkedFund.skipCustRiskMatch;
                if (cb) {
                    cb.call(this, checkedFund);
                }
                return;
            }

            fundApi
                .qryCustRiskMatchService({
                    fundcode: fund.fundcode,
                    invtp: info.invtp,
                    custrisk: info.risklevel
                })
                .then((res) => {
                    if (res.data) {
                        const data = res.data;
                        // allowbuyflag: 0-不允许购买, 1-允许购买
                        const isAllowBuy = data.allowbuyflag === "1";

                        if (!isAllowBuy) {
                            // 不允许购买，弹出阻断提示
                            // 允许页面同步记录阻断状态，例如转换页置灰确认按钮。
                            if (fund.onRiskBlock) {
                                fund.onRiskBlock(data);
                            }
                            Vue.prototype.$lowRiskDialog(fund.risklevel);
                            return false;
                        } else {
                            // 允许购买，继续后续流程
                            if (cb) {
                                cb.call(this, fund);
                            }
                        }
                    } else {
                        // 接口无数据，默认允许购买
                        if (cb) {
                            cb.call(this, fund);
                        }
                    }
                })
                .catch(() => {
                    // 接口异常，默认允许购买（或根据业务需求阻断）
                    if (cb) {
                        cb.call(this, fund);
                    }
                });
        });
    },
    /* 获取产品适当性匹配信息
  @param [Object] _this Vue对象
 @param [Object] fund 待校验基金
 @param [Function] cb 回调方法
 */
    fundRiskCheckWeb(store, router, fund, cb) {
        // 判断用户是否已绑定交易账户
        const _this = this;

        const info = cache.getUser();
        this.getProfession((data) => {
            const _x = Object.assign({}, info, data);
            store.dispatch("setInfo", _x);
            if (
                !cache.getBinded()
                // info.usertype === "2" ||
                // !info.tradingmethod ||
                // info.tradingmethod.indexOf("2") === -1
            ) {
                Vue.prototype
                    .$confirm(
                        "您的账户尚未认证，暂时无法进行购买/定投基金等交易功能，是否立即前往账户认证",
                        "交易手段信息提示",
                        {
                            confirmButtonText: "前往",
                            cancelButtonText: "返回",
                            type: "warning",
                            customClass: "info-check"
                        }
                    )
                    .then(() => {
                        cb.call(this);
                        setTimeout(function () {
                            router.push({
                                name: "bindacctway"
                            });
                        }, 500);
                    })
                    .catch(() => {
                        _this.closeView();
                    });
            } else if (info.lowriskflag === "1") {
                this.request("fund/detail", { fundcode: fund.fundcode }).then((res) => {
                    if (res.data) {
                        if (res.data[0].risklevel && res.data[0].risklevel !== "01") {
                            Vue.prototype
                                .$confirm(
                                    "您当前为最低风险能力承受人，根据证监会销售适当性规定，您不可购买高于您风险等级的产品。",
                                    "最低风险提示",
                                    {
                                        confirmButtonText: "重新评测",
                                        cancelButtonText: "暂不评测",
                                        type: "warning",
                                        customClass: "info-check"
                                    }
                                )
                                .then(() => {
                                    cb.call(this);
                                    setTimeout(function () {
                                        router.push({
                                            name: "risktest"
                                        });
                                    }, 500);
                                })
                                .catch(() => {
                                    _this.closeView();
                                });
                            return false;
                        } else {
                            this.getSdxProtocol(fund, (val) => {
                                if (val && cb) {
                                    cb.call(this, fund);
                                }
                            });
                        }
                    }
                });
            } else {
                this.getSdxProtocol(fund, (val) => {
                    if (val && cb) {
                        cb.call(this, fund);
                    }
                });
            }
        });
    },
    closeView() {
        window.close();
    },

    // 生成交易页适当性放行标志的 sessionStorage key。
    getTradeSdxAccessKey(routeName, fund) {
        const fundcode = typeof fund === "string" ? fund : fund && fund.fundcode;
        if (!routeName || !fundcode) {
            return "";
        }
        return `${TRADE_SDX_ACCESS_PREFIX}${routeName}_${fundcode}`;
    },

    // 发放一次性放行标志，允许用户从合法入口进入对应交易页一次。
    grantTradeSdxAccess(routeName, fund) {
        const accessKey = this.getTradeSdxAccessKey(routeName, fund);
        if (!accessKey) {
            return false;
        }
        sessionStorage.setItem(
            accessKey,
            JSON.stringify({
                routeName,
                fundcode: fund.fundcode,
                createdAt: Date.now()
            })
        );
        return true;
    },

    // 交易页初始化时消费放行标志；没有标志就必须重新走适当性链路。
    consumeTradeSdxAccess(routeName, fund) {
        const accessKey = this.getTradeSdxAccessKey(routeName, fund);
        if (!accessKey) {
            return false;
        }
        const accessToken = sessionStorage.getItem(accessKey);
        if (!accessToken) {
            return false;
        }
        sessionStorage.removeItem(accessKey);
        return true;
    },

    // 保持原有交易页通过 routeName 读取上下文的方式不变。
    storeTradePageFund(routeName, fund) {
        if (!routeName || !fund) {
            return false;
        }
        sessionStorage.setItem(routeName, JSON.stringify(fund));
        return true;
    },

    // 合法入口统一调用：同时写入交易上下文和一次性放行标志。
    grantTradeSdxAccessAndStoreFund(routeName, fund) {
        this.storeTradePageFund(routeName, fund);
        return this.grantTradeSdxAccess(routeName, fund);
    },

    /* 判断是否需要进行适当性判断
        @param [Object] fund 基金对象
        @return [Boolean] 是否需要进行适当性判断
    */
    isNeedSdxCheck(fund) {
        const notNeedSdxCheck = cache.getParamValue("sdx_ignore_fundtype") || [];
        if (fund.fundtype && notNeedSdxCheck.includes(fund.fundtype)) {
            return false;
        }
        return true;
    },
    /*  获取产品适当性匹配信息
        @param [Object] _this Vue对象
        @param [Object] fund 待校验基金
        @param [Function] cb 回调方法
    */
    async getSdxProtocol(fund, cb) {
        // 绑定交易账户做适当性判断
        // cb.call(this, fund);
        // return;
        const res = await fundApi.sdxCheck({
            fundcode: fund.fundcode,
            portfoliocode: fund.portfoliocode
        });
        // this.request(
        //     "acct/sdx/check",
        //     { fundcode: fund.fundcode },
        //     "POST"
        // ).then((res) => {
        if (res.data) {
            const data = res.data;
            if (data) {
                // 查询协议
                if (fund.proto) {
                    // 查询协议
                    this.getProtocol(sceneEnum[fund.proto], fund.fundshowtype || "").then((res) => {
                        data.protoArr = res;
                        // 适当性校验规则
                        if (
                            data.fundmismatchflag === "1" ||
                            data.riskwarnflag === "1" ||
                            data.riskmismatchflag === "1" ||
                            data.highriskwarnflag === "1" ||
                            data.protoArr.length > 0
                        ) {
                            fund.sign = true;
                        }
                        fund = Object.assign(fund, data);
                        if (cb) {
                            cb.call(this, fund);
                        }
                    });
                } else {
                    fund = Object.assign(fund, data);
                    if (cb) {
                        cb.call(this, fund);
                    }
                }
            }
        }
        // });
    },
    /* 获取风险匹配class名
  @param [String] risk 风险值
  @return [String] 匹配的class名称
  */
    riskCla(risk) {
        let cla = "";
        switch (risk) {
            case "01":
                cla = "low";
                break;
            case "02":
                cla = "median-low";
                break;
            case "03":
                cla = "median";
                break;
            case "04":
                cla = "median-high";
                break;
            case "05":
                cla = "high";
                break;
            default:
                break;
        }
        return cla;
    },
    /* 获字符串过滤
  @param [String] val 过滤值
  @return [String] 过滤后的字符串
  */
    filterNum(val) {
        return String(val).replace(/[^0-9]/g, "");
    },
    /* 获取模糊搜索支行信息
   @inParam [Object] _this Vue实例对象
   @inParam [String] queryString 搜索字符串
   @inParam [String] bankid 银行卡ID
   @inParam [Function] cb 回调函数
   */
    querySearch(_this, queryString, bankid, cb, form = "acctInfo") {
        let _z = [];
        const _str = this.filterCode(queryString);
        _this.$set(_this.acctInfo, "bankname", _str);
        if (_this.changCardInfo) {
            _this.$set(_this.changCardInfo, "newBankName", _str);
        }
        clearTimeout(_this.query);
        _this.query = setTimeout(async function () {
            const res = await userApi.bankBranch({
                city: _this[form].city,
                bankcode: bankid,
                banknameaddr: _str
            });
            if (res.data) {
                _this.branchList = res.data.resultList || [];
                if (cb) {
                    _z = _this.branchList.map((arr) => {
                        let _x = {};
                        _x.value = arr.branchname;
                        _x.adress = arr.exchangecode;
                        return _x;
                    });
                    cb(_z);
                }
            }

            // _this.$util
            //     .request(
            //         "common/bankbranch&",
            //         {
            //             city: _this.acctInfo.cityName,
            //             bankcode: bankid,
            //             banknameaddr: _str,
            //         },
            //         false,
            //         false
            //     )
            //     .then((res) => {
            //         if (res.data) {
            //             _this.branchList = res.data;
            //             if (cb) {
            //                 _z = _this.branchList.map((arr) => {
            //                     let _x = {};
            //                     _x.value = arr.branchname;
            //                     _x.adress = arr.exchangecode;
            //                     return _x;
            //                 });
            //                 cb(_z);
            //             }
            //         }
            //     });
        }, 500);
    },
    /* 根据省代码获取对应城市信息
  @inParam [Object] _this Vue实例对象
  @inParam [String] val 取得的省市值
  @inParam [Function] cb 回调函数
  */
    getCity(val, cb) {
        if (val && val !== "") {
            if (Object.keys(cache.get("address")["citylists"]).length == 0) {
                cache.initCityCountyList();
            }
            const cityList = cache.get("address")["citylists"][val] || [];
            if (cb) {
                cb.call(this, cityList);
            }
        }
    },
    /* 获取对应风险描述信息
   @inParam [String] risk 风险代码
   @return [String] val 风险描述信息
   */
    getRiskTest(risk) {
        const riskInfo = CommonConst.RISK_INFO;
        const _x = riskInfo.filter((item) => {
            return item.risk === risk;
        });
        return _x[0].describe;
    },
    /* 获取基金风险过滤信息
  @inParam [String] status 过滤标志
  @return [String] val 风险过滤信息
  */
    riskFilter(status) {
        return status !== "0" ? CommonConst.FUND_RISK_INFO : CommonConst.FUND_HIGHRISK_INFO;
    },
    /* 监测是否开启大写锁定
  @return [String] 是否开启大写锁定
  */
    detectCapsLock() {
        // 大写标志获取
        let capital = sessionStorage.getItem("capital");
        // 无值赋值为0
        if (capital !== "1") {
            capital = "0";
        }
        // 全局事件监听
        let e = event || window.event;
        let keyCode = e.keyCode || e.which; // 按键的keyCode
        let isShift = e.shiftKey || keyCode === 16 || false; // shift键是否按住
        // 是否点击大小切换按钮
        if (keyCode === 20) {
            capital = capital === "1" ? "0" : "1";
        } else if (e.key && e.key.length === 1) {
            // 获取输入字符是否是大写
            if (
                (/[A-Z]/.test(e.key) && !isShift) || // Caps Lock 打开，且没有按住shift键
                (/[a-z]/.test(e.key) && isShift) // Caps Lock 打开，且按住shift键
            ) {
                capital = "1";
            } else if (/[a-z]{1,2}$/.test(e.key)) {
                capital = "0";
            }
        }
        sessionStorage.setItem("capital", capital);
        return capital === "1";
    },
    /* 处理银行卡卡号4位添加空格
  @inParam [String] val 待处理银行卡卡号
  @return [String] 处理后的银行卡号码
  */
    getNewCard(val) {
        const _z = val.length / 4;
        let _new = "";
        for (let i = 0; i < _z; i++) {
            _new += val.substr(4 * i, 4) + "  ";
        }
        return _new.trim();
    },
    /* 处理银行卡卡号4位添加空格
  @inParam [String] val 待处理银行卡卡号
  @return [String] 处理后的银行卡号码
  */
    getDimCard(val) {
        return val.slice(0, -11) + "******" + val.slice(-5);
    },
    /* 计算某个时间前的时间
 @inParam [String] date 时间依据格式20001010
 @inParam [String] num 表示多少月或多少年之前
 @inParam [String] y 表示是否是计算年
 @return [String] 处理后的时间
 */
    getBeginDate(date, num, y) {
        if (num && num !== +num) return;
        let _r = "";
        if (y) {
            _r = (date.substr(0, 4) - num).toString() + date.substr(4);
        } else {
            const _m = Math.floor(num / 12);
            const _o = num % 12;
            const _mo = date.substr(4, 2) - _o;
            if (_mo > 0) {
                _r =
                    date.substr(0, 4) -
                    _m +
                    (_mo > 9 ? _mo : "0" + _mo).toString() +
                    date.substr(6);
            } else {
                _r =
                    date.substr(0, 4) -
                    _m -
                    1 +
                    (_mo < -2 ? "0" + (12 + _mo) : 12 + _mo).toString() +
                    date.substr(6);
            }
        }
        // 处理闰年
        const _rm = _r.substr(4, 2);
        if (_rm === "02" && _r.substr(6, 2) > 28) {
            const _y = _r.substr(0, 4);
            if ((_y % 4 === 0 && _y % 100 !== 0) || _y % 400 === 0) {
                _r = _r.substr(0, 6) + "29";
            } else {
                _r = _r.substr(0, 6) + "28";
            }
            // 处理特殊月份值
        } else if ("04,06,09,11".indexOf(_rm) > -1) {
            if (_r.substr(6, 2) > 30) {
                _r = _r.substr(0, 6) + "30";
            }
        }
        return _r;
    },
    /* 获取费率
  @inParam [String] fund 基金信息
  @inParam [String] cb 回调函数
  */
    getFee(fund, cb) {
        clearTimeout(queryRate);
        if (fund === null) return cb.call(this, {});
        queryRate = setTimeout(async () => {
            const res = await fundApi.qryTransFee(fund);
            if (res.data && cb) {
                cb.call(this, res.data);
            }
        }, 500);
    },
    // 判断一个值是否是 null||undefined||空字符串
    isEmpty(value) {
        if (value === null || value === undefined) return true;
        if (typeof value !== "string") {
            return false;
        }
        value = value.trim();
        if (value === "" || value === " ") {
            return true;
        } else {
            return false;
        }
    },
    promptBindMobileBeforeModify(vm, info) {
        const userInfo = info || cache.getUser() || {};
        const mobileno = userInfo.mobileno || "";
        if (!this.isEmpty(mobileno)) return false;

        vm.$confirm("您尚未增加手机号，为了账户安全，请增加手机号", "温馨提示", {
            confirmButtonText: "去增加",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(() => {
                vm.$router.push({
                    name: "acctManager",
                    query: { activeIndex: "2", next: "mobile" }
                });
            })
            .catch(() => {});
        return true;
    },
    /* 给数据添加一个唯一标识值
 @inParam [Object] data 基金信息
 @return [String] 组装后的数据
 */
    dataTaacFilter(data) {
        if (!(data && data.fundArr && data.fundArr.length > 0)) return;
        const _x = data.fundArr;
        let _arr = [];
        for (let i in _x) {
            _x[i].index = i + "";
            _arr.push(_x[i]);
        }
        data.fundArr = _arr;
        return data;
    },
    /**
     * 调转到网站
     *
     */
    toCompPage(url, params) {
        let _x = "?location=jweb";
        let _url = cache.getCompanyInfoParam("10101006") || "";
        // 没有对应的4.0网站，ump不配置，网交不做跳转
        if (this.isEmpty(_url)) {
            return;
        }
        // 配置地址如下 "http://192.168.8.77:8081/agate/jfit/#"
        if (!(_url.indexOf("https://") > -1 || _url.indexOf("http://") > -1)) {
            Vue.prototype.$alert(
                "基金公司配置跳转地址有误，请联系基金公司修改！",
                "跳转网上交易提示",
                {
                    confirmButtonText: "确定",
                    type: "warning"
                }
            );
            return;
        }
        const _y = _url.substr(_url.length - 1, 1);
        if (_y === "/") {
            _url = _url.substr(0, _url.length - 1);
        }
        if (params) {
            Object.keys(params).forEach((key) => {
                _x += "&" + key + "=" + params[key];
            });
        }
        let openUrl = _url + url + _x;
        window.open(openUrl, "_blank");
    },
    toFundDetailPage(code) {
        const tempStr = cache.getCompanyInfoParam("10102041") || "";
        // 没有对应的4.0网站，ump不配置，网交不做跳转
        if (this.isEmpty(tempStr)) {
            return;
        }
        // 配置地址如下
        if (!(tempStr.indexOf("https://") > -1 || tempStr.indexOf("http://") > -1)) {
            Vue.prototype.$alert(
                "基金公司配置跳转地址有误，请联系基金公司修改！",
                "跳转网上交易提示",
                {
                    confirmButtonText: "确定",
                    type: "warning"
                }
            );
            return;
        }
        // eslint-disable-next-line no-template-curly-in-string
        window.open(tempStr.replaceAll("${fundcode}", code), "_blank");
    },
    /**
     * @Description: 查询风险揭示书
     * @param data
     */
    async queryAgreementFile(data) {
        const riskRes = await fundApi.getProtocol({
            scene: data.scene,
            fundtype: data.fundshowtype
        });
        let riskList = [];
        if (riskRes.data) {
            riskList = riskRes.data.map((item) => {
                return {
                    ...item,
                    filename: item.title,
                    textno: item.fileid,
                    filetype: "2",
                    fileno: item.fileid,
                    isAgreement: true,
                    querytype: data.scene
                };
            });
        }
        return riskList;
    },
    /* 信息披露 获取带阅读文件 */
    /**
     * @Description:
     * @param data 入参
     * @param cb 回调方法
     * @param queryRisk 是否需要展示协议——风险揭示书
     */
    async queryReadFileInfo(data, cb, queryRisk = false) {
        const res = await fundApi.qryFundReadFile(data);
        let riskList = [];
        if (queryRisk) {
            riskList = await this.queryAgreementFile(data);
        }
        if (res.data) {
            cb.call(this, res.data.concat(riskList) || []);
        } else {
            cb.call(this, riskList);
        }
        // this.getGtParamsValue("1001164", (res) => {
        //     if (res.paramvalue.indexOf("A94") > -1) {
        //         this.request("readfile", data, "GET").then((res) => {
        //             if (res.data) {
        //                 cb.call(this, res.data || "");
        //             } else {
        //                 cb.call(this, "");
        //             }
        //         });
        //     } else {
        //         cb.call(this, "");
        //     }
        // });
    },
    /**
     * 留痕信息接口
     */
    async writeFileInfo(data, cb, vueInstance) {
        if (data.readFileInfoList.length === 0) {
            return cb.call(this, "");
        }
        var fileversion = "";
        var textname = "";
        var filenostr = "";
        var texttype = "";
        const readFiles = data.readFileInfoList.filter((item) => !item.isAgreement); // 公告文件
        for (var i = 0; i < readFiles.length; i++) {
            fileversion += data.readFileInfoList[i].fileversion + ",";
            textname += data.readFileInfoList[i].filename + ",";
            filenostr += data.readFileInfoList[i].fileno + ",";
            texttype += data.readFileInfoList[i].filetype + ",";
        }
        const res = await fundApi.fileReadRecord({
            fundcode: data.fundcode,
            fileversion: fileversion.replace(/,$/gi, ""),
            textname: textname.replace(/,$/gi, ""),
            filenostr: filenostr.replace(/,$/gi, ""),
            texttype: texttype.substring(0, texttype.length - 1).replace(/\s/g, "")
        });
        const agreementFiles = data.readFileInfoList.filter((item) => item.isAgreement); // 公告文件
        if (agreementFiles && agreementFiles.length > 0) {
            const querytype = agreementFiles[0].querytype;
            commonApi.agreementLeaveTracesLog(
                vueInstance,
                {
                    eventid:
                        Vue.prototype.$const.RECORD.cms_protocol_agreement_agree + "/" + querytype,
                    eventname: `协议同意`
                },
                agreementFiles
            );
        }
        if (res.data) {
            cb.call(this, res.data.contractno || "");
        } else {
            cb.call(this, "");
        }
    },
    // 登录密码规则提示
    initPwdCheckText() {
        const rules = getLoginPwdRules();
        return getPwdCheckText(rules);
    },
    // 交易密码规则提示
    initTPwdCheckText() {
        const rules = getTradePwdRules();
        return getPwdCheckText(rules);
    },
    // 查询密码规则提示：固定为 6 位纯数字，根据新逻辑简化描述
    initQryPwdCheckText() {
        return "请输入6位纯数字，不能包含空格";
    },
    convertArrToObj(arr, key1, key2) {
        // [{"key1":"val1","key2":"val2"},...] => {"val1":"val2,...}
        if (!(arr instanceof Array)) {
            return {};
        }
        let obj = {};
        arr.forEach((item) => {
            if (!item[key1] || !item[key2]) {
                return {};
            }
            obj[item[key1]] = item[key2];
        });
        return obj;
    },
    checkInfoFilled(obj, excludeItems) {
        // 判断{}必填项是否有值
        if (!obj) {
            return true;
        }
        if (!excludeItems || excludeItems.length == 0) {
            excludeItems = [];
        }
        for (let pro in obj) {
            if (excludeItems.some((item) => item === pro)) {
                continue;
            }
            if (this.isEmpty(obj[pro])) return false;
        }
        return true;
    },
    highriskareaquery(country, location, cb) {
        var belongregion = "";
        if (country == "CN" || country == "156") {
            belongregion = cache.getDict("120120", "0");
        } else {
            belongregion = cache.getDict("120120", "1");
        }
        const _param = {
            belongregion: belongregion,
            location: location
        };
        this.request("orgopen/search/highrisk", _param, "GET").then((res) => {
            if (res.data) {
                cb.call(this, res.data[0].highriskfalg || "");
            }
        });
    },
    specificnaturalper(param, cb) {
        this.request("anon/querySpecialPer", param, "GET").then((res) => {
            if (res.data) {
                cb.call(this, res.data[0] || "");
            }
        });
    },
    adddigniaryorceo(param) {
        this.request("anon/saveBeneficiary", param, "POST").then((res) => {});
    },
    /**
     * 字典将指定值挪到第0位置
     */
    changeArrIndex(arr, id) {
        let index = 1;
        let newArr = [];
        let length = arr.length;
        for (let i = 0; i < length; i++) {
            if (arr[i].subitem == id) {
                newArr[0] = arr[i];
            } else {
                newArr[index++] = arr[i];
            }
        }
        return newArr;
    },
    getGtParamsValue(paraid, cb) {
        let data = {
            paramtype: "1",
            paramname: paraid
        };
        this.request("common/param", data, "GET").then((res) => {
            if (res.data && cb) {
                cb.call(this, res.data[0]);
            }
        });
    },
    getOcrOpenStatus(cb) {
        this.request("/acct/ocr/check", {}, "GET").then((res) => {
            if (res.data && cb) {
                cb.call(this, res.data[0]);
            }
        });
    },
    /* 根据柜台开关判断业务是否需要校验ocr状态
     */
    checkGtOcrModule(id, flag, cb) {
        let paraid = "";
        let checkFlag = false;
        if (flag == "0") {
            paraid = "6000300";
        } else if (flag == "1") {
            paraid = "6000301";
        }
        cb.call(this, { checkFlag: checkFlag });
        /* this.getOcrOpenStatus(res => {
            if (res.isOpenOcr == "1") {
                this.getGtParamsValue (paraid, res => {
                    if (paraid == "6000300") {
                        if (!(res.paramvalue.indexOf(id) > -1)) {
                            checkFlag = true;
                        }
                    } else if (paraid == "6000301") {
                        if (res.paramvalue.indexOf(id) > -1) {
                            checkFlag = true;
                        }
                    }
                    cb.call(this, {"checkFlag": checkFlag});
                });
            }else {
                cb.call(this, {"checkFlag": checkFlag});
            }
        }); */
    },
    showMessage(that, type, obj) {
        var a = [];
        for (let key in obj) {
            a.push(obj[key][0].message);
        }
        that.$message({
            dangerouslyUseHTMLString: true,
            message: a.join("<br/>"),
            type: type
        });
    },
    showMessageBox(
        _this,
        title,
        contentText,
        confirmButtonText,
        cancelButtonText,
        confirmDown,
        closeDown
    ) {
        const h = _this.$createElement;
        _this.$msgbox({
            title: title || "提示",
            message: h("div", null, [h("span", null, contentText)]),
            showClose: false,
            showCancelButton: true,
            confirmButtonText: confirmButtonText || "确认",
            cancelButtonText: cancelButtonText || "取消",
            type: "warning",
            customClass: "info-check",
            beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                    confirmDown();
                    done();
                } else {
                    closeDown();
                    done();
                }
            }
        });
    },
    /**
     * 图片完整路径
     * description: 获取图片完整路径
     * @param imgId: 图片 id
     * @param path: url path, 默认为 /sale-mid-ump/getImgDownload
     * @return 完整的图片 url
     * @createTime:
     */
    imgSrc(params = {}, path = "/sale-mid-ump/file/cmsDownload", flag = false) {
        if (!params.isopenfile) {
            Object.assign(params, { isopenfile: "1" });
        }
        const url = (process.env.NODE_ENV == "production" ? "" : "/h5api") + path;
        let rs = Object.entries(params)
            .map(([key, value]) => {
                return `${key}=${value}`;
            })
            .join("&");
        return url + "?" + rs;
    },
    /**
     * 查询业务是否需要验证交易密码
     * description: 查询业务是否需要验证交易密码
     * @param businesscode: 业务码
     * @param invtp: 客户类型 默认个人
     * @return
     */
    async queryValidPwdTrdMethod(businesscode = "", cb, invtp = "1") {
        const res = await fundApi.queryValidPwdTrdMethod();
        if (res.error) return;
        if (cb) {
            cb.call(
                this,
                res.data.some(
                    (item) =>
                        item.businesscode.includes(businesscode) &&
                        item.invtp &&
                        item.invtp.includes(invtp)
                )
            );
        }
    },
    /* 生成jfit统一文件上传参数
        @inParam [Object] busKey 上传文件业务类型，如10代表基金经理头像，此编号由前后端约定
        @return [Object] 生成的参数，用于ElementUI 的fileUpload 组件的data 属性
    */
    fileUploadParam(busKey, key) {
        return {
            _t: new Date().getTime(),
            busKey: busKey,
            imageKey: key, // 参数配置当多个上传框用来做唯一标识
            g_systemtype: conf.systemtype,
            token: cache.getSessionToken()
        };
    },
    /* 生成jfit统一文件上传header
        @return [Object] 生成的Headers参数，用于ElementUI 的fileUpload 组件的headers 属性
    */
    fileUploadHeader() {
        return {
            g_systemtype: conf.systemtype,
            token: cache.getSessionToken()
        };
    },
    /* 生成jfit统一文件上传路径
        @inParam [Object] p 自定义路径，如不传入的话默认统一文件上传路径/jump/file
        @return [String] 生成的路径，用于ElementUI 的fileUpload 组件的action 属性
    */
    fileUploadPath(p) {
        p = p || "/jump/file";
        if (conf.api.v5BaseUrl == "/") {
            return p;
        }
        return conf.api.v5BaseUrl + p;
    },
    /* 生成jfit统一文件下载路径
  @inParam [String] imgid 文件ID
  @inParam [Number] isopenfile 是否打开文件，1-打开，0-下载
  @inParam [String] token 会话token，作为获取客户信息key
  @return [String] 生成的路径，可直接下载或图片显示
  */
    fileDownloadPath(imgid, isopenfile = 1, token = "") {
        let url = "/sale-mid-ump/file/cmsDownload";
        let params = {
            fileCode: imgid,
            isopenfile: isopenfile
        };
        // 下载时传入token参数，作为获取客户信息key
        if (token) {
            params.token = token;
        }
        let queryStr = "?";
        for (let prop in params) {
            queryStr += prop + "=" + encodeURIComponent(params[prop]) + "&";
        }
        queryStr = queryStr.substring(0, queryStr.length - 1);
        if (conf.api.v5BaseUrl == "/") {
            return url + queryStr;
        }
        return conf.api.v5BaseUrl + url + queryStr;
    },
    capitalRMB(aMount) {
        // 字符长度
        function LengthB(str) {
            var p1 = new RegExp("%u..", "g");
            var p2 = new RegExp("%.", "g");
            return escape(str).replace(p1, "").replace(p2, "").length;
        }

        function covert(aMount) {
            if (isNaN(aMount)) {
                return "不是一个有效的数字，请重新输入！";
            }
            var money1 = Number(aMount);
            if (money1 > 1000000000000000000) {
                return "您输入的数字太大，重新输入！";
            }
            var a = ("" + aMount).replace(/(^0*)/g, "").split(".");
            if (a.length > 1 && LengthB(a[1]) > 2) {
                return "小数点位数不应超过2位";
            }
            var monee = Math.round(money1 * 100).toString(10);
            var i, j;
            j = 0;
            var leng = monee.length;
            var monval = "";
            for (i = 0; i < leng; i++) {
                monval = monval + toUpper(monee.charAt(i)) + toMon(leng - i - 1);
            }
            return repaceAcc(monval);
        }

        function toUpper(a) {
            switch (a) {
                case "0":
                    return "零";
                case "1":
                    return "壹";
                case "2":
                    return "贰";
                case "3":
                    return "叁";
                case "4":
                    return "肆";
                case "5":
                    return "伍";
                case "6":
                    return "陆";
                case "7":
                    return "柒";
                case "8":
                    return "捌";
                case "9":
                    return "玖";
                default:
                    return "";
            }
        }

        function toMon(a) {
            if (a > 10) {
                a = a - 8;
                return toMon(a);
            }
            switch (a) {
                case 0:
                    return "分";
                case 1:
                    return "角";
                case 2:
                    return "元";
                case 3:
                    return "拾";
                case 4:
                    return "佰";
                case 5:
                    return "仟";
                case 6:
                    return "万";
                case 7:
                    return "拾";
                case 8:
                    return "佰";
                case 9:
                    return "仟";
                case 10:
                    return "亿";
            }
        }

        function repaceAcc(Money) {
            Money = Money.replace("零分", "");
            Money = Money.replace("零角", "零");
            var yy;
            var outmoney;
            outmoney = Money;
            yy = 0;
            while (true) {
                var lett = outmoney.length;
                outmoney = outmoney.replace("零元", "元");
                outmoney = outmoney.replace("零万", "万");
                outmoney = outmoney.replace("零亿", "亿");
                outmoney = outmoney.replace("零仟", "零");
                outmoney = outmoney.replace("零佰", "零");
                outmoney = outmoney.replace("零零", "零");
                outmoney = outmoney.replace("零拾", "零");
                outmoney = outmoney.replace("亿万", "亿零");
                outmoney = outmoney.replace("万仟", "万零");
                outmoney = outmoney.replace("仟佰", "仟零");
                yy = outmoney.length;
                if (yy == lett) break;
            }
            yy = outmoney.length;
            if (outmoney.charAt(yy - 1) == "零") {
                outmoney = outmoney.substring(0, yy - 1);
            }
            /* yy = outmoney.length;
            if (outmoney.charAt(yy - 1) == "元") {
                outmoney=outmoney +'整';
            } */
            return outmoney;
        }

        return covert(aMount);
    },
    capitalShare(aMount, sSuffix) {
        // 字符长度
        function LengthB(str) {
            var p1 = new RegExp("%u..", "g");
            var p2 = new RegExp("%.", "g");
            return escape(str).replace(p1, "").replace(p2, "").length;
        }
        var low;
        var i, k, j, lXx1;
        var cap = "";
        var xx1;
        var unit;
        var a = ("" + aMount).replace(/(^0*)/g, "").split(".");
        var digits = "零壹贰叁肆伍陆柒捌玖";
        var units = "份 点拾佰仟万拾佰仟亿拾佰仟万拾佰仟";
        var digit;
        low = parseFloat(aMount);
        if (isNaN(low)) {
            return "";
        }
        xx1 = Math.round(low * 100.0) + "";
        lXx1 = xx1.length;
        for (i = 0; i < lXx1; i++) {
            j = lXx1 - 1 - i;
            unit = units.substr(j, 1);
            // 生成大写单位，即'..份拾...'
            k = parseInt(xx1.substr(i, 1));
            digit = digits.substr(k, 1);
            // 生成大写数字, 即'零壹贰叁...'
            cap = cap + digit + unit;
        }
        cap = cap.replace(" ", "");
        cap = cap.replace(/零拾|零佰|零仟/g, "零");
        cap = cap.replace(/零+/g, "零");
        cap = cap.replace(/零亿/g, "亿");
        cap = cap.replace(/零万/g, "万");
        cap = cap.replace(/零点/g, "点");
        cap = cap.replace(/零份/g, "份");
        cap = cap.replace(/亿万/g, "亿");
        cap = cap.replace(/^壹拾/, "拾");
        cap = cap.replace(/点份$/, "份整");
        cap = cap.replace(/份整$/, "");
        cap = cap.replace(/零$/, "");
        cap = cap.replace(/份$/, "");
        if (a.length > 1 && LengthB(a[1]) > 2) {
            cap = "小数点位数不应超过2位";
            return cap;
        }
        if (a.length > 1 && LengthB(a[0]) == 0 && a[1].charAt(0) != "0") {
            cap = cap.replace("", "零点");
        }
        if (a.length > 1 && LengthB(a[0]) == 0 && a[1].charAt(0) == "0") {
            cap = cap.replace("", "零点零");
        }
        if (cap != "" || cap.length > 0) {
            cap = cap + sSuffix;
        }
        return cap;
    },
    xjbIsOpen() {
        if (cache.getSysParam("10301003")) {
            return cache.getSysParam("10301003").indexOf("T01") != -1;
        } else {
            return false;
        }
    },
    /**
     * 判断是否支持赎回到现金宝
     * CMS参数ID: 10113009
     * 0表示未开通，1表示开通
     * @returns {boolean}
     */
    sellToXjbOpen() {
        return cache.getCompanyInfoParam("10113009") === "1";
    },
    taReToBuyOpen() {
        if (cache.getSysParam("10301003")) {
            return cache.getSysParam("10301003").indexOf("A50") == -1;
        } else {
            return false;
        }
    },
    buyVerificationOpen() {
        // 高龄客户管理
        if (cache.getSysParam("10301003")) {
            return cache.getSysParam("10301003").indexOf("AA3") != -1;
        } else {
            return false;
        }
    },
    actualSellOpen() {
        // 判断是否开启普通T+0赎回
        if (cache.getSysParam("10301003")) {
            return cache.getSysParam("10301003").indexOf("A05") != -1;
        } else {
            return false;
        }
    },
    remitOpen() {
        // 判断是否启用汇款模式
        if (cache.getSysParam("10301003")) {
            return cache.getSysParam("10301003").indexOf("A02") != -1;
        } else {
            return false;
        }
    },
    getRemitTradePayChannel() {
        const tradeInfo = cache.getParamValue("trade_info") || {};
        if (tradeInfo.openremittancechannel) {
            return "0001";
        }

        // 未配置历史汇款渠道时，按汇款交易账号模式送渠道：多交易账号仍用 0001，单交易账号用 XSHK。
        const remitTradeAcctMode = cache.getSysParam("10113006");
        return String(remitTradeAcctMode) === "2" ? "0001" : "XSHK";
    },
    openSalesGuidance() {
        // 判断是否开启网上销售指引
        if (cache.getSysParam("10301003")) {
            return cache.getSysParam("10301003").indexOf("T03") != -1;
        } else {
            return false;
        }
    },
    /* 设置省钱购开关 */
    async opCustTag(custtag = "1", info, cb) {
        info.validdate = info.validdate == "长期有效" ? "99991231" : info.validdate;
        info.actualctrlvalidate =
            info.actualctrlvalidate == "长期有效" ? "99991231" : info.actualctrlvalidate;
        info.benefitvaliddate =
            info.benefitvaliddate == "长期有效" ? "99991231" : info.benefitvaliddate;
        let _obj = Object.assign({}, info, { custtag });
        const res = await userApi.updAcctInfo(_obj);
        if (res.data.appsheetserialno) {
            cache.refreshUser(() => {
                if (cb) {
                    cb();
                }
            });
            info.custtag = custtag;
        }
    },
    /* 获取年月日时分秒时间戳 */
    get14DigitTimestamp() {
        const d = new Date();
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const day = d.getDate().toString().padStart(2, "0");
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const seconds = d.getSeconds().toString().padStart(2, "0");
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
    },
    /* 判断长期有效是否能展示，直销小于46岁不能选择长期有效，代销不判断 */
    isOver46YearsOld(idCard, birthDate = "") {
        // 提取出生日期
        if (birthDate == "") {
            if (idCard.length == 15) {
                birthDate = "19" + idCard.slice(6, 12); // 身份证号码中的出生日期格式为YYYYMMDD
            }
            if (idCard.length == 18) {
                birthDate = idCard.slice(6, 14); // 身份证号码中的出生日期格式为YYYYMMDD
            }
        }
        if (birthDate && cache.getUser().custbelongto != "2") {
            const birthYear = parseInt(birthDate.slice(0, 4));
            const birthMonth = parseInt(birthDate.slice(4, 6));
            const birthDay = parseInt(birthDate.slice(6, 8));

            // 获取当前日期
            const today = new Date();
            const currentYear = today.getFullYear();
            let currentMonth = today.getMonth() + 1; // JS的Month是从0开始的，需要+1
            let currentDay = today.getDate();

            // 计算精确年龄
            let ageYear = currentYear - birthYear;
            if (
                currentMonth < birthMonth ||
                (currentMonth === birthMonth && currentDay < birthDay)
            ) {
                ageYear--; // 如果还没到今年的生日，则减一
            }
            // 判断是否满46岁
            return ageYear >= 46;
        } else {
            // 拿不到birthDate，返回true，让长期有效展示出来
            return true;
        }
    },
    numsDayToText(nums) {
        let text = "";
        switch (nums) {
            case "1":
                text = "一";
                break;
            case "2":
                text = "二";
                break;
            case "3":
                text = "三";
                break;
            case "4":
                text = "四";
                break;
            case "5":
                text = "五";
                break;
            case "6":
                text = "六";
                break;
            case "7":
                text = "日";
                break;
            default:
                break;
        }
        return text;
    },
    getBirthdate(no, type) {
        let birthdate;
        if (no.length === 15) {
            birthdate = "19" + no.substr(type === "00" ? 6 : 7, 6);
        } else if (no.length === 18) {
            birthdate = no.substr(6, 8);
        }
        // 新增校验逻辑
        const year = birthdate.substring(0, 4);
        const month = birthdate.substring(4, 6);
        const day = birthdate.substring(6, 8);
        if (month > 12 || day > 31) return null; // 简单示例
        return birthdate;
    },
    /**
     * 向投资者提示交易时间区间
     * @param fundData: 基金数据
     * @return 时间
     */
    transactionDatePrompt(fundData = {}) {
        const status = fundData.status; // 基金状态
        const dateStr = fundData.ipoenddate; // 募集期结束日期
        const bidstime = fundData.bidstime; // 开放期最晚闭市时间
        const appsubstime = fundData.appsubstime; // 慕集期最晚闭市时间
        const appsubslasttime = fundData.appsubslasttime; // 募集期末日闭市时间
        const year = parseInt(dateStr.substring(0, 4));
        const month = parseInt(dateStr.substring(4, 6)) - 1; // 月份从0开始
        const day = parseInt(dateStr.substring(6, 8));
        const apiDate = new Date(year, month, day);
        // 获取当前日期（本地时区）
        const now = new Date();
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        // 发行状态status:"1"
        // [发行]状态、且不处于募集期结束日期，闭市时间取“慕集期最晚闭市时间”参数
        // [发行]状态、且处于募集期结束日期，闭市时间取“募集期末日闭市时间”参数;
        // 非[发行] 状态，闭市时间取“开放期最晚闭市时间”
        if (status == "1" && apiDate.getTime() === currentDate.getTime()) {
            return appsubslasttime
                ? appsubslasttime.slice(0, 2) + ":" + appsubslasttime.slice(2, 4)
                : "";
        } else if (status == "1" && apiDate.getTime() != currentDate.getTime()) {
            return appsubstime ? appsubstime.slice(0, 2) + ":" + appsubstime.slice(2, 4) : "";
        } else if (status != "1") {
            return bidstime ? bidstime.slice(0, 2) + ":" + bidstime.slice(2, 4) : "";
        }
    },
    // 新窗口打开跳转网页
    openLink(url) {
        window.open(url, "_blank");
    },
    // 购买前校验
    checkComplianceService(fundcode) {
        let dialogType = "";
        let dialogContent = "";
        let dialogButtonText = "";
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            const res = await fundApi.checkComplianceService({
                fundcode: fundcode
            });
            if (res.data) {
                const { limitrule } = res.data;
                // 根据接口返回值设置弹窗参数
                if (limitrule && /[234567]/.test(limitrule)) {
                    // 场景1：限制不可购买（forbid）
                    dialogType = "forbid";
                    dialogContent = buyverificationhtml.forbidHtml;
                    dialogButtonText = "我知道了";
                } else if (limitrule == "1" || limitrule == "8") {
                    // 场景2：限制年龄但未限制购买（warn）
                    dialogType = "warn";
                    const promptInfo = cache.getParamValue("prompt_info");
                    if (promptInfo && promptInfo.highagerisk) {
                        const servicephone = cache.getCompanyInfoParam("10101009") || "";
                        dialogContent = promptInfo.highagerisk.replace(
                            /\{servicephone\}/g,
                            servicephone
                        );
                    } else {
                        dialogContent = buyverificationhtml.warnHtml;
                    }
                    dialogButtonText = "我已完整阅读以上内容并知晓风险";
                }
                resolve({
                    dialogType,
                    dialogContent,
                    dialogButtonText
                });
            } else {
                reject(res);
            }
        });
    },
    /* 判断银行卡bin结果
    @returns [Boolean] 返回是否符合
    */
    async checkBankCardBin(param) {
        const res = await userApi.combCardBinQuery(param);
        // checkflag  检查结果 0-失败 1-成功
        if (res.data && res.data.checkflag && res.data.checkflag == "1") {
            return true;
        } else {
            return false;
        }
    },

    hasFM(obj) {
        // return true; // 临时代码
        return obj.businessflag && obj.businessflag.indexOf("FM") > -1;
    },
    /* 获取用户银行卡列表
    @inParam [String] businessflag 业务控制标志
    @inParam [String] findtype 找回类型
	*/
    async getBusinesBankInfo(params, cb) {
        const res = await userApi.combQryActivatedBankCard({
            biztype: "open",
            businessflag: params.businessflag || "",
            findtype: params.findtype || ""
        });
        if (res && res.data) {
            return res.data;
        }
    },
    // 是否隐藏适当性补录页面
    hideSdx() {
        const accountInfo = cache.getParamValue("account_info");
        if (
            accountInfo &&
            accountInfo.sdxinfofromrisk !== undefined &&
            accountInfo.sdxinfofromrisk === false
        ) {
            return false;
        }
        return true;
    },

    /* 判断基金类型是否符合无需阅读产品文件的产品类型
    @param {string} param - 基金信息 基金的类型代码（例如 "03" 表示混合型）
    @returns {boolean} - 如果基金类型在符合无需阅读产品文件的产品类型中，返回 true；否则返回 false
    */
    async isFundTypeValid(param) {
        try {
            // 获取完整的基金类型字典
            const fundTypeDict = cache.getDict("110144") || [];

            // 获取用户选择的类型配置
            const selectedTypesStr = cache.getCompanyInfoParam("25041501") || "";

            // 将用户选择的字符串转换为数组，并过滤空值
            const selectedTypes = selectedTypesStr.split(",").filter(Boolean);

            // 如果基金类型在用户直接选择的类型中，直接返回true
            if (selectedTypes.includes(param.fundtype)) {
                return true;
            }

            // 如果用户选择了"其他"（即selectedTypes包含"05"）
            // if (selectedTypes.includes("05")) {
            //     // 检查该基金类型是否在字典中存在
            //     const isTypeInDict = fundTypeDict.some((item) => item.subitem === param.fundtype);

            //     // 新增关键判断：如果基金类型是01、02、03、04中的一种
            //     const isCoreType = ["01", "02", "03", "04"].includes(param.fundtype);

            //     // 如果是核心类型，直接返回false
            //     if (isCoreType) {
            //         return false;
            //     }

            //     // 检查该基金类型是否在用户直接选择的具体类型中（除了"05"）
            //     // 注意：用户直接选择的具体类型（除"05"外）已经在上面的步骤4中排除了，所以这里我们只需要检查类型是否存在且不是用户未选择的具体类型（实际上，只要存在且用户没单独选，就属于其他）
            //     // 因此，我们只需要判断该类型在字典中存在，那么它就属于“其他”范畴（因为用户没单独选它，但选了其他）
            //     if (isTypeInDict) {
            //         return true;
            //     }
            // }

            // 其他情况均不符合
            return false;
        } catch (error) {
            console.error("基金类型验证出错:", error);
            return false;
        }
    },
    /**
     * @Description: 截取银行卡后四位（多字段筛选有效后四位，兼容空值/脱敏格式）
     * @param cardParam  支持单字符串/数字 | 多银行卡字段数组
     * @param needBracket 是否需要括号
     */
    lastFour(cardParam, needBracket = false) {
        let cardList = [];
        if (this.isEmpty(cardParam)) {
            cardList = [];
        } else if (Array.isArray(cardParam)) {
            cardList = cardParam;
        } else {
            cardList = [cardParam];
        }

        let validCard = "";
        // 遍历筛选有效字段——非空 + 后四位纯数字（无*、无空格）
        for (const card of cardList) {
            if (this.isEmpty(card)) continue; // 跳过空值
            const cardStr = String(card).trim(); // 转字符串+去首尾空格，处理含空格脱敏值
            // 提取后四位（位数不足4位取全部）
            const lastFourChar =
                cardStr.length > 4 ? cardStr.substring(cardStr.length - 4) : cardStr;
            // 正则校验：后1-4位纯数字，无星号、无空格，判定为有效字段
            if (/^\d{1,4}$/.test(lastFourChar)) {
                validCard = cardStr;
                break; // 找到第一个有效字段立即终止
            }
        }

        // 无有效字段时，取数组最后一个非空字段（多字段则兜底最后一个，单字段则取自身）
        if (!validCard) {
            validCard = cardList.reverse().find((item) => !this.isEmpty(item)) || "";
        }

        let result = "";
        if (!this.isEmpty(validCard)) {
            const finalStr = String(validCard).trim();
            result = finalStr.length > 4 ? finalStr.substring(finalStr.length - 4) : finalStr;
        }

        return needBracket && result ? `(${result})` : result;
    },
    /* 校验交易类型并做出是否要拦截交易入口
     * @param {string} transactionType - 当前交易类型
     * @returns {boolean} 是否需要中断流程并显示弹窗
     */
    async shouldShowCertificateDialog(transactionType) {
        if (transactionType == "025") {
            transactionType = "024"; // 预约赎回也算赎回一种
        }

        // 检查交易类型是否在指定范围内
        const isSpecialTransaction =
            cache.getCompanyInfoParam("25101613").includes(transactionType) ||
            cache.getCompanyInfoParam("25101614").includes(transactionType);

        // “未进行OCR认证的个人投资者限制交易”选择“是”
        const needsCertificateCheck =
            isSpecialTransaction && cache.getCompanyInfoParam("25101611") === "1";

        const userInfo = cache.getUser();
        // 判断证书状态是否需要弹窗
        const isInvalidCertificate = ["", "0", "2"].includes(userInfo.certificatecheck);
        let uploadBtnShow = true;
        if (["00", "0B"].includes(userInfo.certificatetype)) {
            uploadBtnShow = cache.isOcrCertTypeSupported(userInfo.certificatetype);
        }
        return needsCertificateCheck && isInvalidCertificate && uploadBtnShow;
    },
    async getFundCodeListDetail(fundList, targetProps) {
        if (!fundList || fundList.length === 0) return [];

        // 获取基金代码列表
        const fundCodeList = fundList.map((item) => item.fundcode);

        // 批量获取基金详细信息，包括 fundshowtype 和 tradingmethod 字段
        const fundDetailRes = await fundApi.getFundLists({
            fundcodelist: fundCodeList,
            pagesize: fundList.length,
            pagenum: 1,
            fundclass: "",
            ignoretradingmethodflag: "1"
        });

        if (fundDetailRes.data && fundDetailRes.data.list) {
            // 创建基金代码到详细信息的映射
            const fundDetailMap = {};
            fundDetailRes.data.list.forEach((detail) => {
                fundDetailMap[detail.fundcode] = detail;
            });

            fundList.forEach((fund) => {
                targetProps.forEach((prop) => {
                    fund[prop] = fundDetailMap[fund.fundcode]
                        ? fundDetailMap[fund.fundcode][prop]
                        : null;
                });
            });
        }
        return fundList;
    },
    isShowPositionProfit() {
        const assetInfo = cache.getParamValue("asset_info");
        const hideProfit = (assetInfo && assetInfo.disshowcurrencyfundprofit) || "0";
        return hideProfit === "0"; // "0" 表示不隐藏，即展示收益
    },
    /**
     * @Description: 获取渠道显示名称（根据 CMS 参数 10113008 动态展示）
     * @param item - 数据对象（需包含 paycentername/paycenterid/bankcode/netname 等字段）
     * @returns 渠道显示名称
     */
    getChannelName(
        item,
        options = {
            channelSubString: false,
            bankSubString: false,
            subNum: 4
        },
        isHkSpecial = false
    ) {
        if (!item) return "";

        const displayMode = cache.getCompanyInfoParam("10113008") || "1";

        // 如果参数为2且有网点名称，返回网点名称
        if (displayMode === "2" && item.netname) {
            return item.netname;
        }

        // 否则返回渠道名称+银行名称
        // 优先使用 paycentername，为空时使用 paycenterid 通过字典翻译
        const paycentername = item.paycentername || item.paychannelname || "";
        let channelName = "";
        if (isHkSpecial) {
            channelName =
                paycentername === "汇款"
                    ? paycentername
                    : cache.getDict("110079", item.paycenterid);
        } else {
            channelName =
                paycentername ||
                (item.paycenterid || item.paychannel || item.channelid
                    ? cache.getDict("110079", item.paycenterid || item.paychannel || item.channelid)
                    : "");
        }
        const bankName =
            item.bankcode || item.bankid
                ? cache.getDict("110080", item.bankcode || item.bankid)
                : item.bankname;
        let displayBankName = bankName;
        if (options.channelSubString) {
            channelName = (channelName || "").substring(0, options.subNum);
        } else if (options.bankSubString) {
            displayBankName = (bankName || "").substr(-1 * options.subNum, options.subNum);
        }
        return (channelName || "") + "-" + (displayBankName || "");
    },
    /**
     * @Description: 预处理渠道显示数据
     * @param item - 需要预处理的数据对象
     * @param options - 可选配置
     *   - rawdepositcard: {boolean} 是否包含 rawdepositcard 字段
     *   - channelSubString: {boolean} 是否截取渠道名称
     *   - bankSubString: {boolean} 是否截取银行名称
     *   - subNum: {number} 截取长度，默认4
     *   - isHkSpecial: {boolean} 是否港交所特殊处理
     *   - cardFields: {array} 自定义卡号字段数组，默认 ['desendepositcard', 'depositcardproc', 'depositcard']
     * @returns 处理后的数据对象
     */
    preprocessChannelData(item, options = {}) {
        if (!item) return item;

        const {
            rawdepositcard = false,
            channelSubString = false,
            bankSubString = false,
            subNum = 4,
            isHkSpecial = false,
            cardFields = null
        } = options;

        // 添加渠道显示名称（支持配置参数）
        item.channelDisplayName = this.getChannelName(
            item,
            {
                channelSubString,
                bankSubString,
                subNum
            },
            isHkSpecial
        );

        // 确定卡号字段
        const defaultCardFields = [
            item.desendepositcard,
            item.depositcardproc,
            ...(rawdepositcard ? [item.rawdepositcard] : []),
            item.depositcard
        ];
        const finalCardFields = cardFields || defaultCardFields;

        // 添加银行卡尾号
        item.cardTail = this.lastFour(finalCardFields);

        // 添加完整显示文本（渠道名称 + 卡号后四位）
        item.channelDisplayText = item.channelDisplayName + "(" + item.cardTail + ")";

        return item;
    },
    /* 检查是否阻断线上注册/开户
        @description 判断CMS系统参数10102046是否为"1"，若是则弹提示阻断后续逻辑
        @return [Boolean] true-已阻断 false-未阻断 */
    checkRegisterBlocked() {
        if (this.getParamValue("10102046") === "1") {
            Vue.prototype.$alert(
                `当前暂不支持线上注册/开户，详情请联系客服【${cache.getCompanyInfoParam(
                    "10101009"
                )}】`,
                "提示",
                {
                    confirmButtonText: "确定",
                    type: "warning"
                }
            );
            return true;
        }
        return false;
    },
    /* 检查是否阻断线上新增银行卡
        @description 判断CMS系统参数10102047是否为"1"，若是则弹提示阻断后续逻辑
        @return [Boolean] true-已阻断 false-未阻断 */
    checkAddBankBlocked() {
        if (this.getParamValue("10102047") === "1") {
            Vue.prototype.$alert(
                `当前暂不支持线上新增银行卡，详情请联系客服【${cache.getCompanyInfoParam(
                    "10101009"
                )}】`,
                "提示",
                {
                    confirmButtonText: "确定",
                    type: "warning"
                }
            );
            return true;
        }
        return false;
    }
};
